import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  Button,
  Stack,
  IconButton,
  Card,
  CardContent,
  Divider,
  Chip,
  Container,
} from "@mui/material";


// Icons Imports
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import ScreenShareIcon from "@mui/icons-material/ScreenShare";
import StopScreenShareIcon from "@mui/icons-material/StopScreenShare";
import SettingsIcon from "@mui/icons-material/Settings";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CallEndIcon from "@mui/icons-material/CallEnd";


import { useSearchParams } from "react-router-dom";

import SimliAvatar from './SimliAvatar';
import socket from "./socket";
import { Api, UploadFile } from "../webservices"; // Adjust path as needed
// ✅ CORRECT


// const SILENCE_TIMEOUT_MS = 3000;

// Mobile devices need shorter silence detection
const SILENCE_TIMEOUT_MS = 
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) 
    ? 2500 // 1.5 seconds on mobile
    : 5000; // 5 seconds on desktop

// ==========================================
// 1. Voice Interview Component (Active Call Screen)
// ==========================================
function VoiceInterview({ candidate, interviewToken, onEndCall,recordingId }) {
  const [status, setStatus] = useState("connecting"); // connecting | greeting | speaking | listening | processing | completed | error
  const [interviewIds, setInterviewIds] = useState(null);
  // const [recordingId, setRecordingId] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [transcriptPreview, setTranscriptPreview] = useState("");
  const [progress, setProgress] = useState({ answered: 0, total: 0 });
  const [finalResult, setFinalResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
     // Add this state near the top
const [conversationHistory, setConversationHistory] = useState([]);
const [isInterviewStarted, setIsInterviewStarted] = useState(false);
// Add this with other useState declarations
// Add this with other states
const [avatarState, setAvatarState] = useState({
  isSpeaking: false,
  isThinking: false,
  isListening: false,
  text: '',
  emotion: 'neutral'
});
  const recognitionRef = useRef(null);
  const silenceTimerRef = useRef(null);
  const finalTranscriptRef = useRef("");
  const afterListeningRef = useRef(null);
  const noResponseCountRef = useRef(0);
  const isRetryFlowRef = useRef(false);
 
const streamRef = useRef(null);
const mediaRecorderRef = useRef(null);

// ================================
// LIVE RECORDING UPLOAD REFS
// ================================
const uploadIdRef = useRef(null);
const uploadChunkIndexRef = useRef(0);

// Small MediaRecorder pieces are temporarily kept here
// until they reach 10MB or the 10-second flush happens.
const pendingRecordingPartsRef = useRef([]);

const pendingRecordingSizeRef = useRef(0);

// Ensures chunks are uploaded in order.
const uploadQueueRef = useRef(Promise.resolve());

// Used to flush pending data every 10 seconds.
const uploadFlushTimerRef = useRef(null);

const isRecordingStartedRef = useRef(false);
const isFinalizingUploadRef = useRef(false);

const CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB
const CHUNK_TIME = 25 * 1000;        // 10 seconds



  const [videoStream, setVideoStream] = useState(null);
  const videoRef = useRef(null);
  const selectedVoiceRef = useRef(null);
  const isSpeakingRef = useRef(false);
  // const socketRef = useRef(socket);
  const listeningRef = useRef(false);
const shouldKeepListeningRef = useRef(false);
const recognitionRunIdRef = useRef(0);

// Add with other declarations
const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const [isInitialized, setIsInitialized] = useState(false);

// console.log("🎥 Voice Interview Recording ID:", recordingId);
// console.log('ismobile DATA::',isMobile);
// console.log('navigatot.useragent DATA::',navigator.userAgent);

  const handleAnswerValidation = useCallback((data) => {
  console.log("🤖 AI Validation:", data);

  const question = currentQuestionRef.current;

  if (!question) {
    console.warn("⚠️ Current question not found");
    return;
  }

  const answerText =
    finalTranscriptRef.current.trim();

  if (data.isRelevant) {
    console.log("✅ Answer is relevant");

    submitValidatedAnswer(
      data.questionId || question.questionId,
      answerText
    );

    return;
  }

  console.log("❌ Answer is not relevant");

  finalTranscriptRef.current = "";
  setTranscriptPreview("");

  speakText(
    data.botResponse ||
      "Let's focus on the current question. Could you please answer it?",
    () => {
      startListening();
    }
  );
}, []);


  // ── Refs that hold the LATEST values, so closures created once
  // (e.g. inside useCallback) never read stale state ──
  const currentQuestionRef = useRef(null);
  const interviewIdRef = useRef(null);

   const [searchParams] = useSearchParams();

  // const jobTitle = searchParams.get("jobTitle") || "";
  const clientName = searchParams.get("clientName") || "";
  // const fullName = searchParams.get("fullName") || "";
  // const time = searchParams.get("time") || "";
  // const timezone = searchParams.get("timezone") || "";
  const interviewId = searchParams.get("interviewId");
  const token = searchParams.get("token") || "";
  const adminName = searchParams.get("adminName")

  // console.log(" interviewId through params ===>>>>>>>",interviewId);
  useEffect(() => {
    currentQuestionRef.current = currentQuestion;
  }, [currentQuestion]);

  useEffect(() => {
    interviewIdRef.current = interviewIds;
  }, [interviewIds]);

  // useEffect(() => {
  //   startCameraRecording();
  //   joinSession();
  //   return () => {
  //     stopVoiceEngine();
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
  startCameraRecording();
  
  const initInterview = async () => {
    await joinSession();
    setIsInitialized(true);
  };
  
  initInterview();
  
  return () => {
    stopVoiceEngine();
  };
}, []);
  

//   useEffect(() => {
//   const loadVoices = () => {
//     loadBestVoice();
//   };

//   // Chrome mein voices sometimes asynchronously load hoti hain
//   loadVoices();

//   window.speechSynthesis.onvoiceschanged = loadVoices;

//   return () => {
//     window.speechSynthesis.onvoiceschanged = null;
//   };
// }, []);

useEffect(() => {
  const handleVoicesChanged = () => {
    loadBestVoice();
  };

  loadBestVoice();

  window.speechSynthesis.addEventListener(
    "voiceschanged",
    handleVoicesChanged
  );

  return () => {
    window.speechSynthesis.removeEventListener(
      "voiceschanged",
      handleVoicesChanged
    );
  };
}, []);



// Check if mobile and handle accordingly
// useEffect(() => {
//   const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  
//   if (isMobile) {
//     // Mobile: Don't auto-start, wait for user gesture
//     setStatus("greeting");
//     // Show a "Start" button
//   } else {
//     // Desktop: Auto-start
//     startCameraRecording();
//     joinSession();
//   }

//   return () => {
//     stopVoiceEngine();
//   };
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

// ==========================================
// REPLACE this entire useEffect block
// ==========================================

// useEffect(() => {
//   const handleConnect = () => {
//     console.log("✅ Socket connected:", socket.id);
//   };

//   const handleDisconnect = (reason) => {
//     console.log("❌ Socket disconnected:", reason);
//   };

//   const handleProcessing = () => {
//     console.log("🤖 AI relevance processing...");
//     setStatus("processing");
//   };

//   // ENHANCED: Handle relevance result with isQuestion support
//   const handleResult = (data) => {
//     console.log("🤖 relevance_result RECEIVED:", data);

//     const question = currentQuestionRef.current;
//     if (!question) {
//       console.warn("⚠️ Current question not found");
//       return;
//     }

//     const answerText = finalTranscriptRef.current.trim();

//     // Check if candidate asked a question
//     // if (data.isQuestion) {
//     //   console.log("❓ Candidate asked a question");
      
//     //   // Bot will answer the question and redirect
//     //   // The backend has already generated the botResponse
      
//     //   // Add bot response to conversation (if you have a conversation UI)
//     //   // setConversationHistory(prev => [...prev, {
//     //   //   role: 'bot',
//     //   //   content: data.botResponse,
//     //   //   timestamp: new Date().toISOString()
//     //   // }]);

//     //   // Speak the bot's response
//     //   speakText(data.botResponse, () => {
//     //     // After answering, start listening again
//     //     startListening();
//     //   });
      
//     //   return;
//     // }

//    // ==========================================
//   // 1. END INTERVIEW
//   // ==========================================
//   if (data.endInterview) {
//     //  alert('next question please')
//     console.log("🛑 endInterview = true");

//     finalTranscriptRef.current = "";
//     setTranscriptPreview("");

//     completeInterview(interviewIdRef.current);
//     return;
//   }

//   // ==========================================
//   // 2. DON'T KNOW → NEXT QUESTION
//   // ==========================================
//   if (data.dontKnow) {
//     // alert('next question please')
//      console.log("🤷 Candidate doesn't know → Mark answered → Next question");

//   finalTranscriptRef.current = "";
//   setTranscriptPreview("");

//    submitValidatedAnswer(
//     data.questionId || question.questionId,
//     answerText
//   );

//   return;
//   }


//     if (data.isQuestion) {
//   console.log("❓ Candidate asked a question");
//   console.log("🤖 Bot answer:", data.botResponse);

//   speakText(
//     data.botResponse || "Let me clarify that for you.",
//     () => {
//       console.log("🔄 Bot answer finished → listening again");
//       startListening();
//     }
//   );

//   return;
// }

//     // Check if answer is relevant
//     // if (data.isRelevant) {
//     //   console.log("✅ Answer is relevant");
      
//     //   submitValidatedAnswer(
//     //     data.questionId || question.questionId,
//     //     answerText
//     //   );
//     //   return;
//     // }
//     if (data.isRelevant) {
//   console.log("✅ Answer is relevant");
//   console.log("🤖 Bot Response:", data.botResponse);
//   console.log("➡️ Should Proceed:", data.shouldProceed);

//   // Pehle bot response bulwao
//   speakText(
//     data.botResponse || "Got it, thanks for sharing that.",
//     async () => {
//       // Bot response complete hone ke baad answer submit karo
//       await submitValidatedAnswer(
//         data.questionId || question.questionId,
//         answerText
//       );
//     }
//   );

//   return;
// }

//     // Answer is not relevant - redirect
//     console.log("❌ Answer is not relevant");
    
//     finalTranscriptRef.current = "";
//     setTranscriptPreview("");

//     speakText(
//       data.botResponse ||
//         "Let's focus on the current question. Could you please answer it?",
//       () => {
//         startListening();
//       }
//     );
//   };

//   const handleError = (err) => {
//     console.error("❌ Relevance error:", err);
//     setStatus("error");
//     setErrorMessage(
//       err?.message || "Could not analyze your answer."
//     );
//   };

// // Add this inside your socket useEffect (around line 200)
// const onAvatarState = (data) => {
//   console.log('🎭 Avatar State:', data);
//   setAvatarState({
//     isSpeaking: data.isSpeaking || false,
//     isThinking: data.isThinking || false,
//     isListening: data.isListening || false,
//     text: data.text || '',
//     emotion: data.emotion || 'neutral'
//   });
// };

//   // Socket event listeners
//   socket.on("connect", handleConnect);
//   socket.on("disconnect", handleDisconnect);
//   socket.on("relevance_processing", handleProcessing);
//   socket.on("relevance_result", handleResult);
//   socket.on("relevance_error", handleError);
//   socket.on("avatar_state", onAvatarState); // ✅ NEW

//   if (socket.connected) {
//     console.log("⚡ Socket already connected");
//     handleConnect();
//   }

//   return () => {
//     socket.off("connect", handleConnect);
//     socket.off("disconnect", handleDisconnect);
//     socket.off("relevance_processing", handleProcessing);
//     socket.off("relevance_result", handleResult);
//     socket.off("relevance_error", handleError);
//     socket.off("avatar_state", onAvatarState); // ✅ NEW
//   };
// }, []);

useEffect(() => {
  // ✅ CRITICAL: Store socket globally for SimliAvatar
  window.__socket = socket;
    console.log("📡 [App] Socket stored globally for SimliAvatar");
  console.log("📡 [App] Socket ID:", socket.id);
  console.log("📡 [App] Socket connected:", socket.connected);

  const handleConnect = () => {
    console.log("✅ Socket connected:", socket.id);
    // Update global socket reference when reconnected
    window.__socket = socket;
  };

  const handleDisconnect = (reason) => {
    console.log("❌ Socket disconnected:", reason);
  };

  const handleProcessing = () => {
    console.log("🤖 AI relevance processing...");
    setStatus("processing");
  };

  const handleResult = (data) => {
    console.log("🤖 relevance_result RECEIVED:", data);

    const question = currentQuestionRef.current;
    if (!question) {
      console.warn("⚠️ Current question not found");
      return;
    }

    const answerText = finalTranscriptRef.current.trim();

    // ==========================================
    // 1. END INTERVIEW
    // ==========================================
    if (data.endInterview) {
      console.log("🛑 endInterview = true");
      finalTranscriptRef.current = "";
      setTranscriptPreview("");
      completeInterview(interviewIdRef.current);
      return;
    }

    // ==========================================
    // 2. DON'T KNOW → NEXT QUESTION
    // ==========================================
    if (data.dontKnow) {
      console.log("🤷 Candidate doesn't know → Mark answered → Next question");
      finalTranscriptRef.current = "";
      setTranscriptPreview("");
      submitValidatedAnswer(
        data.questionId || question.questionId,
        answerText
      );
      return;
    }

    if (data.isQuestion) {
      console.log("❓ Candidate asked a question");
      console.log("🤖 Bot answer:", data.botResponse);

      speakText(
        data.botResponse || "Let me clarify that for you.",
        () => {
          console.log("🔄 Bot answer finished → listening again");
          startListening();
        }
      );
      return;
    }

    if (data.isRelevant) {
      console.log("✅ Answer is relevant");
      console.log("🤖 Bot Response:", data.botResponse);
      console.log("➡️ Should Proceed:", data.shouldProceed);

      speakText(
        data.botResponse || "Got it, thanks for sharing that.",
        async () => {
          await submitValidatedAnswer(
            data.questionId || question.questionId,
            answerText
          );
        }
      );
      return;
    }

    // Answer is not relevant - redirect
    console.log("❌ Answer is not relevant");
    finalTranscriptRef.current = "";
    setTranscriptPreview("");

    speakText(
      data.botResponse ||
        "Let's focus on the current question. Could you please answer it?",
      () => {
        startListening();
      }
    );
  };

  const handleError = (err) => {
    console.error("❌ Relevance error:", err);
    setStatus("error");
    setErrorMessage(
      err?.message || "Could not analyze your answer."
    );
  };

  // ✅ Avatar state listener
  const onAvatarState = (data) => {
    console.log('🎭 Avatar State:', data);
    setAvatarState({
      isSpeaking: data.isSpeaking || false,
      isThinking: data.isThinking || false,
      isListening: data.isListening || false,
      text: data.text || '',
      emotion: data.emotion || 'neutral'
    });
  };

  // Socket event listeners
  socket.on("connect", handleConnect);
  socket.on("disconnect", handleDisconnect);
  socket.on("relevance_processing", handleProcessing);
  socket.on("relevance_result", handleResult);
  socket.on("relevance_error", handleError);
  socket.on("avatar_state", onAvatarState);

  if (socket.connected) {
    console.log("⚡ Socket already connected");
    handleConnect();
  }

  return () => {
    socket.off("connect", handleConnect);
    socket.off("disconnect", handleDisconnect);
    socket.off("relevance_processing", handleProcessing);
    socket.off("relevance_result", handleResult);
    socket.off("relevance_error", handleError);
    socket.off("avatar_state", onAvatarState);
  };
}, [socket]);

// useEffect(() => {
//   console.log("🔥 useEffect running");
//   console.log("Socket connected:", socket.connected);
//   console.log("Socket ID:", socket.id);
  
//   const handleConnect = () => {
//     // alert("UseEffect Call")
//     console.log("✅ Socket connected:", socket.id);
//   };

//   const handleDisconnect = (reason) => {
//     // alert("UseEffect Call Disconnect")
//     console.log("❌ Socket disconnected:", reason);
//   };

//   const handleProcessing = () => {
//     console.log("🤖 AI relevance processing...");
//     setStatus("processing");
//   };

//   const handleResult = (data) => {
//     console.log("🤖 relevance_result RECEIVED:", data);

//     /*
//       Agar backend:
      
//       {
//         questionId,
//         isRelevant,
//         botResponse
//       }

//       bhej raha hai, to usko aapke existing
//       handleAnswerValidation ke format mein convert kar rahe hain.
//     */

//     const normalizedData = {
//       ...data,

//       classification:
//         data.classification ??
//         (data.isRelevant ? "relevant" : "unrelated"),

//       response:
//         data.response ??
//         data.botResponse,
//     };

//     handleAnswerValidation(normalizedData);
//   };

//   const handleError = (err) => {
//     console.error("❌ Relevance error:", err);

//     setStatus("error");
//     setErrorMessage(
//       err?.message || "Could not analyze your answer."
//     );
//   };

//   socket.on("connect", handleConnect);
//   socket.on("disconnect", handleDisconnect);

//   socket.on(
//     "relevance_processing",
//     handleProcessing
//   );

//   socket.on(
//     "relevance_result",
//     handleResult
//   );

//   socket.on(
//     "relevance_error",
//     handleError
//   );

//   if (socket.connected) {
//     console.log("⚡ Socket already connected, calling handleConnect manually");
//     handleConnect();
//   }

//   return () => {
//     socket.off("connect", handleConnect);
//     socket.off("disconnect", handleDisconnect);

//     socket.off(
//       "relevance_processing",
//       handleProcessing
//     );

//     socket.off(
//       "relevance_result",
//       handleResult
//     );

//     socket.off(
//       "relevance_error",
//       handleError
//     );
//   };
// }, [handleAnswerValidation]);


// useEffect(() => {
//   const handleConnect = () => {
//     console.log("✅ Socket connected:", socket.id);

//     if (interviewIdRef.current) {
//       socket.emit("join_interview", {
//         interviewId: interviewIdRef.current,
//       });
//     }
//   };

//   const handleDisconnect = () => {
//     console.log("❌ Socket disconnected");
//   };

//   const handleProcessing = () => {
//     console.log("🤖 AI relevance processing...");
//     setStatus("processing");
//   };

//   const handleResult = (data) => {
//     console.log("🤖 Relevance Result:", data);

//     setStatus("processing");

//     const question = currentQuestionRef.current;

//     if (!question) {
//       console.error("Current question not found");
//       return;
//     }

//     const answer = finalTranscriptRef.current.trim();

//     if (data.isRelevant) {
//       submitValidatedAnswer(
//         data.questionId,
//         answer
//       );
//     } else {
//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakText(
//         data.botResponse ||
//           "Let's focus on the current question. Could you please answer it?",
//         () => {
//           startListening();
//         }
//       );
//     }
//   };

//   const handleError = (err) => {
//     console.error("❌ Relevance error:", err);

//     setStatus("error");

//     setErrorMessage(
//       err?.message ||
//         "Could not analyze your answer."
//     );
//   };

//   socket.on("connect", handleConnect);
//   socket.on("disconnect", handleDisconnect);
//   socket.on("relevance_processing", handleProcessing);
//   socket.on("relevance_result", handleResult);
//   socket.on("relevance_error", handleError);

//   return () => {
//     socket.off("connect", handleConnect);
//     socket.off("disconnect", handleDisconnect);
//     socket.off(
//       "relevance_processing",
//       handleProcessing
//     );
//     socket.off(
//       "relevance_result",
//       handleResult
//     );
//     socket.off(
//       "relevance_error",
//       handleError
//     );
//   };
// }, []);

  const stopVoiceEngine = () => {
    if (recognitionRef.current) recognitionRef.current.stop();
    if (silenceTimerRef.current) clearTimeout(silenceTimerRef.current);
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  };

const handleStartInterview = () => {
  setIsInterviewStarted(true);
  // Start speech recognition after user gesture
  setTimeout(() => {
    startListening();
  }, 100);
};

// Add a fallback for mobile if speech recognition fails
// const startListeningWithFallback = useCallback(() => {
//   // Try speech recognition first
//   try {
//     startListening();
//   } catch (error) {
//     console.error("Speech recognition failed, using fallback:", error);
//     // Fallback: Use button to submit answer
//     setStatus("listening");
//     setErrorMessage("Tap 'Submit Answer' when you're done speaking");
//   }
// }, [startListening]);

// const loadBestVoice = () => {
//   const voices = window.speechSynthesis.getVoices();

//   if (!voices.length) {
//     return null;
//   }

//   console.log(
//     "Available voices:",
//     voices.map((v) => ({
//       name: v.name,
//       lang: v.lang,
//       localService: v.localService,
//     }))
//   );

//   const preferredVoiceNames = [
//     "Microsoft Jenny Online",
//     "Microsoft Jenny",
//     "Microsoft Aria Online",
//     "Microsoft Aria",
//     "Microsoft Guy Online",
//     "Microsoft Guy",
//     "Google US English",
//     "Google UK English Female",
//     "Google UK English Male",
//   ];

//   // Find preferred voice without for...of
//   const preferredVoice = preferredVoiceNames
//     .map((preferredName) =>
//       voices.find((voice) =>
//         voice.name
//           .toLowerCase()
//           .includes(preferredName.toLowerCase())
//       )
//     )
//     .find(Boolean);

//   if (preferredVoice) {
//     selectedVoiceRef.current = preferredVoice;
//     return preferredVoice;
//   }

//   // Fallback: US English
//   const usVoice = voices.find(
//     (voice) => voice.lang === "en-US"
//   );

//   if (usVoice) {
//     selectedVoiceRef.current = usVoice;
//     return usVoice;
//   }

//   // Fallback: any English voice
//   const englishVoice = voices.find(
//     (voice) => voice.lang.startsWith("en")
//   );

//   if (englishVoice) {
//     selectedVoiceRef.current = englishVoice;
//     return englishVoice;
//   }

//   return null;
// };


  const loadBestVoice = () => {
  const voices = window.speechSynthesis.getVoices();

  // console.log(
  //   "🎙️ Voices:",
  //   voices.map((v) => ({
  //     name: v.name,
  //     lang: v.lang,
  //   }))
  // );

  if (!voices.length) {
    return null;
  }

  const preferredVoice =
    voices.find(
      (v) =>
        v.name.toLowerCase().includes("jenny") &&
        v.lang.toLowerCase().startsWith("en")
    ) ||
    voices.find(
      (v) =>
        v.name.toLowerCase().includes("aria") &&
        v.lang.toLowerCase().startsWith("en")
    ) ||
    voices.find(
      (v) => v.lang === "en-US"
    ) ||
    voices.find(
      (v) => v.lang.startsWith("en")
    );

  selectedVoiceRef.current = preferredVoice || null;

  // console.log(
  //   "🎙️ Selected voice:",
  //   preferredVoice?.name,
  //   preferredVoice?.lang
  // );

  return preferredVoice || null;
};

  // const joinSession = async () => {
  //   const body = { interviewToken };

  //   try {
  //     const res = await Api("bot/interview_session_join", "POST", body, token);
  //     const data = await res.data;
  //     console.log("Data Recieved::",data)
  //     if (!data.success) {
  //       setStatus("error");
  //       setErrorMessage(data.message);
  //       return;
  //     }

  //     setInterviewId(data.data.interviewId);
  //     interviewIdRef.current = data.data.interviewId; // sync immediately, don't wait for effect
  //     setProgress({ answered: 0, total: data.data.totalQuestions });

  //       // ✅ ADD THIS: Send Simli keys to backend
  //   if (socket && socket.connected) {
  //     socket.emit('init_interview', {
  //       interviewId: data.data.interviewId,
  //       simliApiKey: process.env.REACT_APP_SIMLI_API_KEY,
  //       simliFaceId: process.env.REACT_APP_SIMLI_FACE_ID
  //     });
  //   }
  //      console.log("🗣️ ABOUT TO SPEAK GREETING");
  //     speakIntroGreeting(data.data.candidateName, data.data.interviewId);
  //   } catch (err) {
  //     setStatus("error");
  //     setErrorMessage("Could not connect to interview server.");
  //   }
  // };

  // const speakIntroGreeting = (name, id) => {
  //   setStatus("greeting");
  //   const firstName = name ? name.split(" ")[0] : "";
  //   const greetingText = firstName
  //     ? `Hello ${firstName}, I'm your AI interview assistant. I'll be asking you a few questions today. Please answer each question after you hear it, and pause when you're done speaking. Let's get started.`
  //     : `Hello, I'm your AI interview assistant. I'll be asking you a few questions today. Please answer each question after you hear it, and pause when you're done speaking. Let's get started.`;

  //   const utterance = new SpeechSynthesisUtterance(greetingText);
  //   utterance.rate = 1;
  //   utterance.pitch = 1;

  //   utterance.onend = () => fetchNextQuestion(id);
  //   utterance.onerror = () => fetchNextQuestion(id);

  //   window.speechSynthesis.cancel();
  //   window.speechSynthesis.speak(utterance);
  // };

// const speakIntroGreeting = (name, id) => {
//   setStatus("greeting");

//   const firstName = name ? name.split(" ")[0] : "";
//   // const adminName = localStorage.getItem("contactPersonName");
//   const greetingText = firstName
//     ? `Hi ${firstName}, this is ${adminName} from ${clientName}. How are you doing today?`
//     : `Hello, I'm your AI interview assistant. I'll be asking you a few questions today. Please answer each question after you hear it, and pause when you're done speaking. Let's get started.`;

//   const utterance = new SpeechSynthesisUtterance(greetingText);

//   utterance.rate = 0.8;
//   utterance.pitch = 0.8;

//   utterance.onend = () => {
//     // Greeting complete → listen candidate
//     afterListeningRef.current = () => {
//       speakInterviewIntroduction(id);
//     };

//     startListening();
//   };

//   utterance.onerror = () => {
//     afterListeningRef.current = () => {
//       speakInterviewIntroduction(id);
//     };

//     startListening();
//   };

//   window.speechSynthesis.cancel();
//   window.speechSynthesis.speak(utterance);
// };





const joinSession = async () => {
  const body = { interviewToken };

  try {
    const res = await Api("bot/interview_session_join", "POST", body, token);
    const data = await res.data;
    console.log("📊 [App] Data Received:", data);
    
    if (!data.success) {
      setStatus("error");
      setErrorMessage(data.message);
      return;
    }
    // initiateRecording();
    setInterviewIds(data.data.interviewId);
    interviewIdRef.current = data.data.interviewId;
    setProgress({ answered: 0, total: data.data.totalQuestions });

    // ✅ Check socket connection
    console.log("📡 [App] Socket connected:", socket?.connected);
    console.log("📡 [App] Socket ID:", socket?.id);
    console.log("📡 [App] window.__socket exists:", !!window.__socket);

    // ✅ Send Simli keys to backend
    if (socket && socket.connected) {
      console.log("📤 [App] Sending init_interview with Simli keys");
      console.log("📤 [App] SIMLI_API_KEY exists:", !!process.env.REACT_APP_SIMLI_API_KEY);
      console.log("📤 [App] SIMLI_FACE_ID:", process.env.REACT_APP_SIMLI_FACE_ID);
      
      socket.emit('init_interview', {
        interviewId: data.data.interviewId,
        simliApiKey: process.env.REACT_APP_SIMLI_API_KEY,
        simliFaceId: process.env.REACT_APP_SIMLI_FACE_ID
      });
      console.log("✅ [App] init_interview sent");
    } else {
      console.warn("⚠️ [App] Socket not connected, cannot send init_interview");
      console.warn("⚠️ [App] Socket state:", socket);
    }
    
    console.log("🗣️ [App] ABOUT TO SPEAK GREETING");
    speakIntroGreeting(data.data.candidateName, data.data.interviewId);
  } catch (err) {
    console.error("❌ [App] joinSession error:", err);
    setStatus("error");
    setErrorMessage("Could not connect to interview server.");
  }
};

const speakIntroGreeting = (name, id) => {
  setStatus("greeting");

  const firstName = name ? name.split(" ")[0] : "";

  const greetingText = firstName
    ? `Hi ${firstName}, this is ${adminName} from ${clientName}. How are you doing today?`
    : `Hello, I'm your AI interview assistant. I'll be asking you a few questions today. Please answer each question after you hear it, and pause when you're done speaking. Let's get started.`;

  speakText(greetingText, () => {
    afterListeningRef.current = () => {
      speakInterviewIntroduction(id);
    };

    startListening();
  });
};

// const speakInterviewIntroduction = (id) => {
//   setStatus("greeting");

//   const introductionText =
//     "Thank you for taking the time to speak with me today. " +
//     "This interview will take around 20–30 minutes. " +
//     "I'll begin by learning a little about your background, " +
//     "then we'll discuss your experience, the role, and I will walk you through " +
//     "the roles and responsibilities of this job. " +
//     "Does that sound good?";

//   const utterance = new SpeechSynthesisUtterance(introductionText);

//   utterance.rate = 0.8;
//   utterance.pitch = 0.8;

//   utterance.onend = () => {
//     // Second paragraph complete → listen candidate again
//     afterListeningRef.current = () => {
//       fetchNextQuestion(id);
//     };

//     startListening();
//   };

//   utterance.onerror = () => {
//     afterListeningRef.current = () => {
//       fetchNextQuestion(id);
//     };

//     startListening();
//   };

//   window.speechSynthesis.cancel();
//   window.speechSynthesis.speak(utterance);
// };

const speakInterviewIntroduction = (id) => {
  setStatus("greeting");

  const introductionText =
    "Thank you for taking the time to speak with me today. " +
    "This interview will take around 20 to 30 minutes. " +
    "I'll begin by learning a little about your background, " +
    "then we'll discuss your experience and the role. " +
    "I'll also walk you through the roles and responsibilities of the job. " +
    "Does that sound good?";

  speakText(introductionText, () => {
    afterListeningRef.current = () => {
      fetchNextQuestion(id);
    };

    startListening();
  });
};

  const fetchNextQuestion = async (id) => {
    setStatus("processing");

    const body = { interviewId: id };

    try {
      const res = await Api("bot/interview_session_next_question", "POST", body, token);
      const data = await res.data;

      if (!data.success) {
        setStatus("error");
        setErrorMessage(data.message);
        return;
      }

      setProgress({
        answered: data.data.answeredCount,
        total: data.data.totalQuestions,
      });

      if (data.data.completed) {
        completeInterview(id);
        return;
      }

      setCurrentQuestion(data.data.question);
      currentQuestionRef.current = data.data.question; // sync immediately
      speakQuestion(data.data.question.question);
    } catch (err) {
      setStatus("error");
      setErrorMessage("Could not fetch next question.");
    }
  };

//   const handleAnswerValidation = useCallback((data) => {
//   console.log("🤖 AI Validation:", data);

//   const question = currentQuestionRef.current;

//   if (!question) return;

//   switch (data.classification) {

//     case "relevant":
//       submitValidatedAnswer(
//         data.interviewId,
//         data.questionId
//       );
//       break;

//     case "repeat_request":
//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakQuestion(question.question);
//       break;

//     case "unrelated":
//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakText(
//         data.response ||
//           "Let's focus on the current question. Could you please answer it?",
//         () => {
//           startListening();
//         }
//       );
//       break;

//     case "unclear":
//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakText(
//         "I didn't quite understand your response. Could you please explain it again?",
//         () => {
//           startListening();
//         }
//       );
//       break;

//     case "incomplete":
//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakText(
//         "Could you please provide a little more detail?",
//         () => {
//           startListening();
//         }
//       );
//       break;

//     default:
//       startListening();
//   }
// }, []);

// const submitCurrentAnswer = () => {
//   const question = currentQuestionRef.current;
//   const id = interviewIdRef.current;

//   if (!question || !id) {
//     return;
//   }

//   const answerText =
//     finalTranscriptRef.current.trim();

//   if (!answerText) {
//     handleNoResponse();
//     return;
//   }

//   if (!socket.connected) {
//     console.error("❌ Socket is not connected");

//     setStatus("error");
//     setErrorMessage(
//       "Connection lost. Please try again."
//     );

//     return;
//   }

//   setStatus("processing");

//   console.log("📤 Checking answer relevance:", {
//     interviewId: id,
//     questionId: question.questionId,
//     question: question.question,
//     answer: answerText,
//   });

//   socket.emit("check_relevance", {
//     interviewId: id,
//     questionId: question.questionId,
//     question: question.question,
//     answerText,
//   });
// };

  // const speakQuestion = (text) => {
  //   setStatus("speaking");
  //   setTranscriptPreview("");

  //   const utterance = new SpeechSynthesisUtterance(text);
  //   utterance.rate = 0.8;
  //   utterance.pitch = 0.8;

  //   utterance.onend = () => startListening();
  //   utterance.onerror = () => startListening();

  //   window.speechSynthesis.cancel();
  //   window.speechSynthesis.speak(utterance);
  // };




//   const submitCurrentAnswer = () => {
//   const question = currentQuestionRef.current;
//   const id = interviewIdRef.current;

//   if (!question || !id) {
//     return;
//   }

//   const answerText = finalTranscriptRef.current.trim();

//   if (!answerText) {
//     handleNoResponse();
//     return;
//   }

//   const emitAnswer = () => {
//     setStatus("processing");

//     console.log("📤 Checking answer relevance:", {
//       interviewId: id,
//       questionId: question.questionId,
//       question: question.question,
//       answer: answerText,
//     });

//     socket.emit("check_relevance", {
//       interviewId: id,
//       questionId: question.questionId,
//       question: question.question,
//       answerText,
//     });
//   };

//   if (!socket.connected) {
//     console.warn("⚠️ Socket disconnected. Waiting for connection...");

//     setStatus("connecting");
//     setErrorMessage("Reconnecting...");

//     socket.once("connect", emitAnswer);
//     socket.connect();

//     return;
//   }

//   emitAnswer();
// };

// const submitCurrentAnswer = () => {
//   const question = currentQuestionRef.current;
//   const id = interviewIdRef.current;

//   if (!question || !id) {
//     return;
//   }

//   const answerText = finalTranscriptRef.current.trim();

//   if (!answerText) {
//     handleNoResponse();
//     return;
//   }

//   // Check if candidate is asking for question repeat
//   if (isRepeatQuestionRequest(answerText)) {
//     noResponseCountRef.current = 0;
//     setTranscriptPreview("");
//     finalTranscriptRef.current = "";
//     speakQuestion(currentQuestionRef.current.question);
//     return;
//   }

//   const emitAnswer = () => {
//     setStatus("processing");

//     console.log("📤 Checking answer relevance:", {
//       interviewId: id,
//       questionId: question.questionId,
//       question: question.question,
//       answer: answerText,
//     });

//     socket.emit("check_relevance", {
//       interviewId: id,
//       questionId: question.questionId,
//       question: question.question,
//       answerText,
//       // Add conversation history for context (if you maintain it)
//       // conversationHistory: conversationHistory,
//     });
//   };

//   if (!socket.connected) {
//     console.warn("⚠️ Socket disconnected. Waiting for connection...");
//     setStatus("connecting");
//     setErrorMessage("Reconnecting...");
//     socket.once("connect", emitAnswer);
//     socket.connect();
//     return;
//   }

//   emitAnswer();
// };

const submitCurrentAnswer = () => {
  const question = currentQuestionRef.current;
  const id = interviewIdRef.current;

  if (!question || !id) {
    console.warn("⚠️ No question or interview ID");
    return;
  }

  const answerText = finalTranscriptRef.current.trim();
  
  // CRITICAL: Check for empty answer
  if (!answerText) {
    console.log("⚠️ Empty answer in submitCurrentAnswer");
    handleNoResponse();
    return;
  }

  // Check if candidate is asking to repeat question
  if (isRepeatQuestionRequest(answerText)) {
    console.log("🔄 Candidate asked to repeat question");
    noResponseCountRef.current = 0;
    setTranscriptPreview("");
    finalTranscriptRef.current = "";
    speakQuestion(currentQuestionRef.current.question);
    return;
  }

  // Emit answer to socket
  const emitAnswer = () => {
    setStatus("processing");
    console.log("📤 Sending answer to server:", {
      interviewId: id,
      questionId: question.questionId,
      answer: answerText
    });

    socket.emit("check_relevance", {
      interviewId: id,
      questionId: question.questionId,
      question: question.question,
      answerText,
    });
  };

  if (!socket.connected) {
    console.warn("⚠️ Socket disconnected. Reconnecting...");
    setStatus("connecting");
    socket.once("connect", emitAnswer);
    socket.connect();
    return;
  }

  emitAnswer();
};

// const submitCurrentAnswer = () => {
//   const question = currentQuestionRef.current;
//   const id = interviewIdRef.current;

//   if (!question || !id) {
//     return;
//   }

//   const answerText = finalTranscriptRef.current.trim();

//   // ❌ Empty answer → socket event mat bhejo
//   if (!answerText) {
//     handleNoResponse();
//     return;
//   }

//   // Baaki normal answer flow
//   const emitAnswer = () => {
//     setStatus("processing");

//     socket.emit("check_relevance", {
//       interviewId: id,
//       questionId: question.questionId,
//       question: question.question,
//       answerText,
//     });
//   };

//   if (!socket.connected) {
//     socket.once("connect", emitAnswer);
//     socket.connect();
//     return;
//   }

//   emitAnswer();
// };





const startListening = useCallback(() => {
  // Clean up existing recognition
  if (recognitionRef.current) {
    recognitionRef.current.onend = null;
    recognitionRef.current.onerror = null;
    try {
      recognitionRef.current.abort();
    } catch (e) {
      console.debug("Recognition already stopped");
    }
    recognitionRef.current = null;
  }

  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognition) {
    setStatus("error");
    setErrorMessage(
      "Voice recognition is not supported in this browser. Please use Chrome or Edge."
    );
    return;
  }

  // CRITICAL: Request microphone permission first
  navigator.mediaDevices.getUserMedia({ audio: true })
    .then((stream) => {
      // Stop the stream immediately, we just need permission
      stream.getTracks().forEach(track => track.stop());
      
      setStatus("listening");
      finalTranscriptRef.current = "";
      setTranscriptPreview("");
      
      const recognition = new SpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.lang = "en-US";
      
      // Mobile-specific: Set longer timeout
      if (isMobile) {
        recognition.maxAlternatives = 3;
      }
      
      recognition.onresult = (event) => {
        let interim = "";
        for (let i = event.resultIndex; i < event.results.length; i += 1) {
          const chunk = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscriptRef.current += `${chunk} `;
          } else {
            interim += chunk;
          }
        }
        const transcript = (finalTranscriptRef.current + interim).trim();
        console.log("🎤 Candidate speaking:", transcript);
        // 📱 MOBILE ONLY
         if (isMobile && transcript) { alert(`Candidate said:\n\n${transcript}`); }
        setTranscriptPreview(transcript);
        resetSilenceTimer();
      };

      recognition.onerror = (event) => {
        console.log("Speech recognition error:", event.error);
        
        if (event.error === "not-allowed") {
          setStatus("error");
          setErrorMessage("Microphone permission denied. Please allow microphone access.");
        } else if (event.error === "audio-capture") {
          // Mobile: Retry after short delay
          if (isMobile && status === "listening") {
            setTimeout(() => {
              if (status === "listening") {
                startListening();
              }
            }, 1000);
          }
        } else if (event.error === "no-speech") {
          // On mobile, just keep listening
          if (isMobile && status === "listening") {
            // Don't stop, just reset timer
            resetSilenceTimer();
          }
        }
      };

      // CRITICAL FIX FOR MOBILE: Properly handle onend
      recognition.onend = () => {
        console.log("🔄 Recognition ended");
        
        if (silenceTimerRef.current) {
          clearTimeout(silenceTimerRef.current);
        }

        const answer = finalTranscriptRef.current.trim();
        console.log("📝 Final answer:", answer);

        // 📱 MOBILE DEBUG
         if (isMobile && answer) { alert(`🎤 Candidate actually spoke:\n\n${answer}`); }

        // ==========================================
        // 1. INTRO FLOW
        // ==========================================
        if (afterListeningRef.current) {
          const nextAction = afterListeningRef.current;
          afterListeningRef.current = null;
          nextAction();
          return;
        }

        // ==========================================
        // 2. EMPTY ANSWER - Mobile restart
        // ==========================================
        if (!answer) {
          console.log("⚠️ Empty answer");
          
          // Mobile: Restart listening immediately
          if (isMobile) {
            console.log("📱 Mobile: Restarting listening for empty answer");
            setTimeout(() => {
              if (status !== "completed" && status !== "error") {
                startListening();
              }
            }, 300);
            return;
          }
          
          // Desktop: Ask to answer
          speakText("Please answer the question.", () => {
            startListening();
          });
          return;
        }

        // ==========================================
        // 3. RETRY YES/NO FLOW
        // ==========================================
        if (isRetryFlowRef.current) {
          console.log("🔄 Retry answer:", answer);
          
          const normalizedAnswer = answer.toLowerCase().trim();
          
          if (normalizedAnswer === "yes" || 
              normalizedAnswer.includes("yes please") ||
              normalizedAnswer.includes("please repeat")) {
            isRetryFlowRef.current = false;
            noResponseCountRef.current = 0;
            finalTranscriptRef.current = "";
            setTranscriptPreview("");
            speakQuestion(currentQuestionRef.current.question);
            return;
          }
          
          if (normalizedAnswer === "no" || 
              normalizedAnswer.includes("no thank you")) {
            isRetryFlowRef.current = false;
            noResponseCountRef.current = 0;
            finalTranscriptRef.current = "";
            setTranscriptPreview("");
            speakText("Please answer the question.", () => {
              startListening();
            });
            return;
          }
          
          // If user said something else during retry, treat as normal answer
          console.log("❓ User said something during retry:", answer);
          // Continue to normal answer flow
        }

        // ==========================================
        // 4. NORMAL ANSWER
        // ==========================================
        submitCurrentAnswer();
      };

      recognitionRef.current = recognition;
      
      // CRITICAL: Start recognition
      try {
        recognition.start();
        console.log("🎤 Recognition started");
      } catch (e) {
        console.error("Failed to start recognition:", e);
        // Mobile: Retry after short delay
        if (isMobile) {
          setTimeout(() => {
            if (status === "listening") {
              startListening();
            }
          }, 500);
        }
      }
      
      resetSilenceTimer();
    })
    .catch((err) => {
      console.error("Microphone permission error:", err);
      setStatus("error");
      setErrorMessage("Please allow microphone access to continue.");
    });
}, []);

// const startListening = useCallback(() => {
//   // Check if recognition already exists
//   if (recognitionRef.current) {
//     recognitionRef.current.onend = null;
//     recognitionRef.current.onerror = null;
//     try {
//       recognitionRef.current.stop();
//     } catch (e) {
//       console.debug("Recognition already stopped");
//     }
//     recognitionRef.current = null;
//   }

//   const SpeechRecognition =
//     window.SpeechRecognition || window.webkitSpeechRecognition;

//   if (!SpeechRecognition) {
//     setStatus("error");
//     setErrorMessage(
//       "Voice recognition is not supported in this browser. Please use Chrome or Edge."
//     );
//     return;
//   }

//   // CRITICAL: Request microphone permission explicitly
//   navigator.mediaDevices.getUserMedia({ audio: true })
//     .then((stream) => {
//       // Stop the stream immediately, we just need permission
//       stream.getTracks().forEach(track => track.stop());
      
//       setStatus("listening");
//       finalTranscriptRef.current = "";
      
//       const recognition = new SpeechRecognition();
//       recognition.continuous = true;
//       recognition.interimResults = true;
//       recognition.lang = "en-US";
      
//       // Mobile-specific settings
//       recognition.maxAlternatives = 1;
      
//       recognition.onresult = (event) => {
//         let interim = "";
//         for (let i = event.resultIndex; i < event.results.length; i += 1) {
//           const chunk = event.results[i][0].transcript;
//           if (event.results[i].isFinal) {
//             finalTranscriptRef.current += `${chunk} `;
//           } else {
//             interim += chunk;
//           }
//         }
//         const transcript = (finalTranscriptRef.current + interim).trim();
//         console.log("🎤 Candidate speaking:", transcript);
//         setTranscriptPreview(transcript);
//         resetSilenceTimer();
//       };

//       // recognition.onerror = (event) => {
//       //   console.log("Speech recognition error:", event.error);
//       //   if (event.error === "not-allowed") {
//       //     setStatus("error");
//       //     setErrorMessage("Microphone permission denied. Please allow microphone access.");
//       //   } else if (event.error === "audio-capture") {
//       //     // Retry on mobile audio capture issues
//       //     setTimeout(() => {
//       //       if (status === "listening") {
//       //         startListening();
//       //       }
//       //     }, 500);
//       //   }
//       // };

//       // In your recognition.onerror handler
// recognition.onerror = (event) => {
//   console.log("Speech recognition error:", event.error);
  
//   if (event.error === "not-allowed") {
//     setStatus("error");
//     setErrorMessage("Microphone access denied. Please enable microphone in browser settings.");
//   } else if (event.error === "audio-capture") {
//     // Mobile often needs retry
//     setTimeout(() => {
//       if (status === "listening") {
//         // Request mic permission again
//         navigator.mediaDevices.getUserMedia({ audio: true })
//           .then(stream => {
//             stream.getTracks().forEach(track => track.stop());
//             if (recognitionRef.current) {
//               recognitionRef.current.start();
//             }
//           })
//           .catch(() => {
//             setStatus("error");
//             setErrorMessage("Cannot access microphone. Please try again.");
//           });
//       }
//     }, 1000);
//   } else if (event.error === "no-speech") {
//     // No speech detected, keep listening
//     if (status === "listening") {
//       // Don't stop, just keep listening
//     }
//   }
// };

// //       recognition.onend = () => {
// //         if (silenceTimerRef.current) {
// //           clearTimeout(silenceTimerRef.current);
// //         }

// //         // Intro flow
// //         if (afterListeningRef.current) {
// //           const nextAction = afterListeningRef.current;
// //           afterListeningRef.current = null;
// //           nextAction();
// //           return;
// //         }

// //         // Retry flow (Yes / No)
// //         // if (isRetryFlowRef.current) {
// //         //   isRetryFlowRef.current = false;
// //         //   const answer = finalTranscriptRef.current.trim().toLowerCase();
// //         //   console.log("Retry Answer:", answer);

// //         //   if (answer.includes("yes")) {
// //         //     noResponseCountRef.current = 0;
// //         //     speakQuestion(currentQuestionRef.current.question);
// //         //     return;
// //         //   }

// //         //   if (answer.includes("no")) {
// //         //     noResponseCountRef.current = 0;
// //         //     isRetryFlowRef.current = false;
// //         //     speakText("Please answer the question.", () => {
// //         //       startListening();
// //         //     });
// //         //     return;
// //         //   }

// //         //   handleNoResponse();
// //         //   return;
// //         // }

// //  if (isRetryFlowRef.current) {
// //   const answer = finalTranscriptRef.current.trim();

// //   console.log("🔄 Retry flow answer:", answer);

// //   // Empty answer
// //   if (!answer) {
// //     handleNoResponse();
// //     return;
// //   }

// //   const normalizedAnswer = answer.toLowerCase();

// //   // YES
// //   if (
// //     normalizedAnswer === "yes" ||
// //     normalizedAnswer.includes("yes please") ||
// //     normalizedAnswer.includes("please repeat")
// //   ) {
// //     isRetryFlowRef.current = false;
// //     noResponseCountRef.current = 0;

// //     finalTranscriptRef.current = "";
// //     setTranscriptPreview("");

// //     speakQuestion(currentQuestionRef.current.question);

// //     return;
// //   }

// //   // NO
// //   if (
// //     normalizedAnswer === "no" ||
// //     normalizedAnswer.includes("no thank you")
// //   ) {
// //     isRetryFlowRef.current = false;
// //     noResponseCountRef.current = 0;

// //     finalTranscriptRef.current = "";
// //     setTranscriptPreview("");

// //     speakText("Please answer the question.", () => {
// //       startListening();
// //     });

// //     return;
// //   }

// //   // Candidate asked something
// //   console.log("❓ Candidate asked something during retry");

// //   // IMPORTANT:
// //   // retry mode true hi rakho
// //   // socket candidate ke question ko process karega

// //   submitCurrentAnswer();

// //   return;
// // }

// //         // Normal interview answer
// //         submitCurrentAnswer();
// //       };

// recognition.onend = () => {
//   if (silenceTimerRef.current) {
//     clearTimeout(silenceTimerRef.current);
//   }

//   const answer = finalTranscriptRef.current.trim();

//   console.log("🎤 Recognition ended. Answer:", answer);

//   // ==========================================
//   // 1. Intro flow
//   // ==========================================
//   if (afterListeningRef.current) {
//     const nextAction = afterListeningRef.current;
//     afterListeningRef.current = null;
//     nextAction();
//     return;
//   }

//   // ==========================================
//   // 2. EMPTY ANSWER
//   // ==========================================
//   if (!answer) {
//     console.log("⚠️ Empty answer - NO SOCKET EVENT");

//     finalTranscriptRef.current = "";
//     setTranscriptPreview("");

//     // Candidate ko dobara answer dene bolo
//     speakText(
//       "Please answer the question.",
//       () => {
//         console.log("🎤 Listening again for answer...");

//         finalTranscriptRef.current = "";
//         setTranscriptPreview("");

//         startListening();
//       }
//     );

//     return;
//   }

//   // ==========================================
//   // 3. Retry YES / NO flow
//   // ==========================================
//   if (isRetryFlowRef.current) {
//     console.log("🔄 Retry answer:", answer);

//     const normalizedAnswer = answer.toLowerCase();

//     // YES
//     if (
//       normalizedAnswer === "yes" ||
//       normalizedAnswer.includes("yes please") ||
//       normalizedAnswer.includes("please repeat")
//     ) {
//       isRetryFlowRef.current = false;
//       noResponseCountRef.current = 0;

//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakQuestion(currentQuestionRef.current.question);

//       return;
//     }

//     // NO
//     if (
//       normalizedAnswer === "no" ||
//       normalizedAnswer.includes("no thank you")
//     ) {
//       isRetryFlowRef.current = false;
//       noResponseCountRef.current = 0;

//       finalTranscriptRef.current = "";
//       setTranscriptPreview("");

//       speakText(
//         "Please answer the question.",
//         () => {
//           finalTranscriptRef.current = "";
//           setTranscriptPreview("");

//           startListening();
//         }
//       );

//       return;
//     }

//     // Candidate ne koi question poocha
//     console.log("❓ Candidate asked something:", answer);

//     submitCurrentAnswer();

//     return;
//   }

//   // ==========================================
//   // 4. NORMAL ANSWER
//   // ==========================================
//   submitCurrentAnswer();
// };

//       recognitionRef.current = recognition;
//       recognition.start();
//       resetSilenceTimer();
//     })
//     .catch((err) => {
//       console.error("Microphone permission error:", err);
//       setStatus("error");
//       setErrorMessage("Please allow microphone access to continue.");
//     });
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

// Helper to detect if candidate is asking to repeat the question
// const isRepeatQuestionRequest = (text = "") => {
//   const normalized = text
//     .toLowerCase()
//     .replace(/[^\w\s]/g, "")
//     .trim();

//   const repeatKeywords = [
//     "repeat question",
//     "please repeat question",
//     "please repeat the question",
//     "can you repeat question",
//     "can you repeat the question",
//     "could you repeat the question",
//     "repeat it",
//     "repeat",
//     "say that again",
//     "come again",
//     "pardon",
//     "sorry repeat",
//     "i didn't hear",
//     "i did not hear",
//     "what was the question",
//     "question again",
//     "can you say that again",
//     "could you say that again"
//   ];

//   return repeatKeywords.some(keyword => normalized.includes(keyword));
// };

  const speakQuestion = (text) => {
  setStatus("speaking");
  setTranscriptPreview("");

  speakText(text, () => {
    startListening();
  });
};

//   const startListening = useCallback(() => {
//     if (recognitionRef.current) {
//     recognitionRef.current.onend = null;
//     recognitionRef.current.onerror = null;

//     try {
//       recognitionRef.current.stop();
//     } catch (e) {
//       console.debug("Recognition already stopped");
//     }

//     recognitionRef.current = null;
//   }

//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;

//     if (!SpeechRecognition) {
//       setStatus("error");
//       setErrorMessage(
//         "Voice recognition is not supported in this browser. Please use Chrome or Edge."
//       );
//       return;
//     }

//     setStatus("listening");
//     finalTranscriptRef.current = "";
//     console.log("Listening started");
//     console.log("Initial answer:", finalTranscriptRef.current);
//     const recognition = new SpeechRecognition();
//     recognition.continuous = true;
//     recognition.interimResults = true;
//     recognition.lang = "en-US";

//     recognition.onresult = (event) => {
//       let interim = "";
//       for (let i = event.resultIndex; i < event.results.length; i += 1) {
//         const chunk = event.results[i][0].transcript;
//         if (event.results[i].isFinal) {
//           finalTranscriptRef.current += `${chunk} `;
//         } else {
//           interim += chunk;
//         }
//       }
//       // setTranscriptPreview((finalTranscriptRef.current + interim).trim());
//        const transcript = (
//     finalTranscriptRef.current + interim
//   ).trim();

//   console.log("🎤 Candidate speaking:", transcript);

//   setTranscriptPreview(transcript);
//       resetSilenceTimer();
//     };

//     recognition.onerror = (event) => {
//       if (event.error !== "no-speech") {
//         console.log("Speech recognition error:", event.error);
//       }
//     };

//     // recognition.onend = () => {
//     //   if (silenceTimerRef.current) clearTimeout(silenceTimerRef.current);
//     //   submitCurrentAnswer();
//     // };

// //     recognition.onend = () => {
// //   if (silenceTimerRef.current) {
// //     clearTimeout(silenceTimerRef.current);
// //   }

// //   if (afterListeningRef.current) {
// //     const nextAction = afterListeningRef.current;

// //     afterListeningRef.current = null;

// //     nextAction();
// //     return;
// //   }

// //   submitCurrentAnswer();
// // };

// // recognition.onend = () => {
// //   if (silenceTimerRef.current) {
// //     clearTimeout(silenceTimerRef.current);
// //   }

// //   // Intro flow
// //   if (afterListeningRef.current) {
// //     const nextAction = afterListeningRef.current;

// //     afterListeningRef.current = null;

// //     nextAction();
// //     return;
// //   }

// //   // Retry flow (Yes / No)
// //   if (isRetryFlowRef.current) {

// //     isRetryFlowRef.current = false;

// //     const answer = finalTranscriptRef.current
// //       .trim()
// //       .toLowerCase();

// //     console.log("Retry Answer:", answer);

// //     if (answer.includes("yes")) {

// //       noResponseCountRef.current = 0;

// //       // Repeat current question
// //       speakQuestion(currentQuestionRef.current.question);

// //       return;
// //     }

// //     if (answer.includes("no")) {
// //     noResponseCountRef.current = 0;
// //     isRetryFlowRef.current = false;

// //     speakText("Please answer the question.", () => {
// //         startListening();
// //     });

// //     return;
// // }

// //     // if (answer.includes("no")) {
// //     //     speakText("Please answer the question.");
// //     //   // Wait 10 sec then listen again
// //     //   // setTimeout(() => {
// //     //     startListening();
// //     //   // }, 10000);

// //     //   return;
// //     // }

// //     // Didn't say yes/no
// //     handleNoResponse();
// //     return;
// //   }

// //   // Normal interview answer
// //   submitCurrentAnswer();
// // };

// recognition.onend = () => {
//   if (silenceTimerRef.current) {
//     clearTimeout(silenceTimerRef.current);
//   }

//   // Intro flow
//   if (afterListeningRef.current) {
//     const nextAction = afterListeningRef.current;
//     afterListeningRef.current = null;
//     nextAction();
//     return;
//   }

//   // Retry flow (Yes / No)
//   if (isRetryFlowRef.current) {
//     isRetryFlowRef.current = false;
//     const answer = finalTranscriptRef.current.trim().toLowerCase();

//     console.log("Retry Answer:", answer);

//     if (answer.includes("yes")) {
//       noResponseCountRef.current = 0;
//       speakQuestion(currentQuestionRef.current.question);
//       return;
//     }

//     if (answer.includes("no")) {
//       noResponseCountRef.current = 0;
//       isRetryFlowRef.current = false;
//       speakText("Please answer the question.", () => {
//         startListening();
//       });
//       return;
//     }

//     // Didn't say yes/no
//     handleNoResponse();
//     return;
//   }

//   // Normal interview answer
//   submitCurrentAnswer();
// };

//     recognitionRef.current = recognition;
//     recognition.start();
//     resetSilenceTimer();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);




  const resetSilenceTimer = () => {
    if (silenceTimerRef.current) clearTimeout(silenceTimerRef.current);
    silenceTimerRef.current = setTimeout(() => {
      if (recognitionRef.current) recognitionRef.current.stop();
    }, SILENCE_TIMEOUT_MS);
  };

// const startCameraRecording = async () => {
//   try {
//     console.log("🎥 Requesting camera permission...");
//     // const stream = await navigator.mediaDevices.getUserMedia({
//     //   video: true,
//     //   audio: true,
//     // });
//     const stream = await navigator.mediaDevices.getUserMedia({
//         video: {
//         facingMode: "user",
//          },
//         audio: true,
//         });

//        console.log("✅ Camera Stream:", stream);
//     console.log("📹 Video Tracks:", stream.getVideoTracks());
//     console.log("🎤 Audio Tracks:", stream.getAudioTracks());


//       stream.getVideoTracks().forEach((track) => {
//       console.log("Video Track Details:", {
//         label: track.label,
//         enabled: track.enabled,
//         readyState: track.readyState,
//         settings: track.getSettings(),
//       });
//     });

//     streamRef.current = stream;
//     setVideoStream(stream);   // <-- this triggers re-render

//     recordedChunksRef.current = [];

//     const recorder = new MediaRecorder(stream, {
//       mimeType: "video/webm",
//     });

//     mediaRecorderRef.current = recorder;

//     recorder.ondataavailable = (e) => {
//       if (e.data.size > 0) {
//         recordedChunksRef.current.push(e.data);
//       }
//     };

//     recorder.start(1000);
//   } catch (err) {
//     console.log(err);
//   }
// };

const createRecordingUploadId = () => {
  const uploadId =
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random()
          .toString(36)
          .substring(2, 10)}`;

  uploadIdRef.current = uploadId;
  uploadChunkIndexRef.current = 0;

  pendingRecordingPartsRef.current = [];
  pendingRecordingSizeRef.current = 0;

  console.log("🆔 Recording upload session created:", uploadId);

  return uploadId;
};



const startCameraRecording = async () => {
  try {
    console.log(
      "🎥 Starting camera + microphone + LIVE upload..."
    );

    // ==========================================
    // CREATE UPLOAD SESSION BEFORE RECORDING
    // ==========================================
    const uploadId = createRecordingUploadId();

    console.log(
      "🆔 LIVE recording uploadId:",
      uploadId
    );

    // ==========================================
    // GET CAMERA + MICROPHONE
    // ==========================================
    const stream =
      await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "user",
        },
        audio: true,
      });

    console.log(
      "✅ Recording stream received:",
      stream
    );

    streamRef.current = stream;

    setVideoStream(stream);

    // ==========================================
    // RESET LIVE UPLOAD STATE
    // ==========================================
    pendingRecordingPartsRef.current = [];
    pendingRecordingSizeRef.current = 0;

    uploadChunkIndexRef.current = 0;

    uploadQueueRef.current =
      Promise.resolve();

    isRecordingStartedRef.current = false;
    isFinalizingUploadRef.current = false;

    // ==========================================
    // BROWSER MIME TYPE
    // ==========================================
    let mimeType = "video/webm";

    if (
      MediaRecorder.isTypeSupported(
        "video/webm;codecs=vp8,opus"
      )
    ) {
      mimeType =
        "video/webm;codecs=vp8,opus";
    } else if (
      MediaRecorder.isTypeSupported(
        "video/webm"
      )
    ) {
      mimeType = "video/webm";
    } else {
      console.warn(
        "⚠️ video/webm not supported. Browser may use another format."
      );
    }

    console.log(
      "🎞️ MediaRecorder MIME type:",
      mimeType
    );

    // ==========================================
    // CREATE RECORDER
    // ==========================================
    const recorder = new MediaRecorder(
      stream,
      {
        mimeType,
      }
    );

    mediaRecorderRef.current =
      recorder;

    // ==========================================
    // DATA AVAILABLE
    // ==========================================
    recorder.ondataavailable = (
      event
    ) => {
      if (
        !event.data ||
        event.data.size === 0
      ) {
        return;
      }

      console.log(
        "📦 MediaRecorder data:",
        {
          sizeKB: (
            event.data.size /
            1024
          ).toFixed(2),
        }
      );

      // Add this small piece to our temporary buffer.
      pendingRecordingPartsRef.current.push(
        event.data
      );

      pendingRecordingSizeRef.current +=
        event.data.size;

      console.log(
        "📊 Pending recording buffer:",
        {
          sizeMB: (
            pendingRecordingSizeRef.current /
            (1024 * 1024)
          ).toFixed(2),
        }
      );

      // ========================================
      // UPLOAD WHEN BUFFER REACHES 10MB
      // ========================================
      if (
        pendingRecordingSizeRef.current >=
        CHUNK_SIZE
      ) {
        flushPendingRecordingChunk();
      }
    };

    // ==========================================
    // RECORDER ERROR
    // ==========================================
    recorder.onerror = (event) => {
      console.error(
        "❌ MediaRecorder error:",
        event
      );
    };

    // ==========================================
    // RECORDER START
    // ==========================================
    recorder.onstart = () => {
      isRecordingStartedRef.current =
        true;

      console.log(
        "🔴 LIVE VIDEO RECORDING STARTED"
      );

      console.log(
        "📡 Chunks will upload when they reach 10MB or every 10 seconds."
      );
    };

    // ==========================================
    // RECORDER STOP
    // ==========================================
    recorder.onstop = () => {
      console.log(
        "⏹️ MediaRecorder stopped"
      );
    };

    // ==========================================
    // START RECORDING
    //
    // 1000ms means ondataavailable
    // approximately every second.
    //
    // We then combine those pieces until:
    //
    // 10MB reached
    // OR
    // 10 seconds elapsed
    // ==========================================
    recorder.start(1000);

    // ==========================================
    // 10 SECOND FLUSH TIMER
    // ==========================================
    uploadFlushTimerRef.current =
      setInterval(() => {
        if (
          pendingRecordingPartsRef.current
            .length === 0
        ) {
          return;
        }

        console.log(
          "⏰ 10 seconds reached → uploading current recording chunk"
        );

        flushPendingRecordingChunk({
          force: true,
        });
      }, CHUNK_TIME);

  } catch (error) {
    console.error(
      "❌ Camera recording start error:",
      error
    );

    setErrorMessage(
      "Could not access camera or microphone. Please check browser permissions."
    );
  }
};



const stopCameraRecording = () =>
  new Promise((resolve, reject) => {
    const recorder =
      mediaRecorderRef.current;

    console.log(
      "⏹️ Stopping LIVE recording..."
    );

    // ==========================================
    // STOP 10 SECOND TIMER
    // ==========================================
    if (
      uploadFlushTimerRef.current
    ) {
      clearInterval(
        uploadFlushTimerRef.current
      );

      uploadFlushTimerRef.current =
        null;
    }

    // ==========================================
    // NO RECORDER
    // ==========================================
    if (!recorder) {
      console.warn(
        "⚠️ MediaRecorder not found"
      );

      resolve();
      return;
    }

    // ==========================================
    // ALREADY STOPPED
    // ==========================================
    if (
      recorder.state === "inactive"
    ) {
      flushPendingRecordingChunk({
        force: true,
      });

      resolve();
      return;
    }

    // ==========================================
    // ON STOP
    // ==========================================
   recorder.onstop = async () => {
  try {
    console.log("⏹️ MediaRecorder stopped");

    // Upload whatever is still pending
    flushPendingRecordingChunk({
      force: true,
    });

    // Wait for ALL queued uploads
    await uploadQueueRef.current;

    console.log(
      "✅ All live recording chunks uploaded"
    );

    if (streamRef.current) {
      streamRef.current
        .getTracks()
        .forEach((track) => {
          track.stop();
        });

      streamRef.current = null;
    }

    setVideoStream(null);

    mediaRecorderRef.current = null;

    isRecordingStartedRef.current = false;

    resolve();
  } catch (error) {
    console.error(
      "❌ Error while stopping recording:",
      error
    );

    reject(error);
  }
};

    recorder.onerror = (event) => {
      console.error(
        "❌ Recorder stop error:",
        event
      );

      reject(
        new Error(
          "Failed to stop video recording"
        )
      );
    };

    // ==========================================
    // FORCE FINAL MEDIARECORDER DATA
    // ==========================================
    try {
      recorder.requestData();
    } catch (error) {
      console.warn(
        "⚠️ requestData failed:",
        error
      );
    }

    recorder.stop();
  });


// const stopCameraRecording = () => {
//   return new Promise((resolve) => {
//     const recorder = mediaRecorderRef.current;

//     if (!recorder) {
//       resolve(null);
//       return;
//     }

//     recorder.onstop = () => {
//       const blob = new Blob(recordedChunksRef.current, {
//         type: "video/webm",
//       });

//       resolve(blob);
//     };

//     recorder.stop();

//     if (streamRef.current) {
//       streamRef.current.getTracks().forEach((track) => track.stop());
//     }
//   });
// };


const queueRecordingChunkUpload = (chunkBlob) => {
  const uploadId = uploadIdRef.current;

  if (!uploadId) {
    console.error(
      "❌ Cannot upload chunk: uploadId not created"
    );
    return;
  }

  const chunkIndex = uploadChunkIndexRef.current;

  uploadChunkIndexRef.current += 1;

  console.log(
    `📦 Queueing recording chunk ${chunkIndex + 1}`,
    {
      chunkIndex,
      sizeMB: (
        chunkBlob.size /
        (1024 * 1024)
      ).toFixed(2),
    }
  );

  uploadQueueRef.current =
    uploadQueueRef.current.then(() =>
      uploadRecordingChunk({
        chunkBlob,
        uploadId,
        chunkIndex,
      })
    );
};


const flushPendingRecordingChunk = ({
  force = false,
} = {}) => {
  const parts =
    pendingRecordingPartsRef.current;

  if (!parts.length) {
    return;
  }

  const currentSize =
    pendingRecordingSizeRef.current;

  if (
    !force &&
    currentSize < CHUNK_SIZE
  ) {
    return;
  }

  const chunkBlob = new Blob(parts, {
    type: "video/webm",
  });

  console.log(
    "📦 Preparing LIVE upload chunk:",
    {
      sizeMB: (
        chunkBlob.size /
        (1024 * 1024)
      ).toFixed(2),
      force,
    }
  );

  // Clear buffer immediately
  pendingRecordingPartsRef.current = [];
  pendingRecordingSizeRef.current = 0;

  queueRecordingChunkUpload(chunkBlob);
};


const uploadRecordingChunk = async ({
  chunkBlob,
  uploadId,
  chunkIndex,
}) => {
  if (!chunkBlob || chunkBlob.size === 0) {
    console.warn("⚠️ Empty recording chunk. Skipping upload.");
    return null;
  }

  const formData = new FormData();

  formData.append("uploadId", uploadId);

  // IMPORTANT:
  // Chunk index remains 0-based:
  // 0, 1, 2, 3...
  formData.append("chunkIndex", String(chunkIndex));

  formData.append("totalChunks", String( 1+ chunkIndex ));

  // We don't know totalChunks while recording.
  // Backend should allow this to be omitted / unknown.
  formData.append("chunk", chunkBlob, `chunk_${chunkIndex}.webm`);

  console.log(
    `📤 Uploading LIVE chunk ${chunkIndex + 1}`,
    {
      uploadId,
      chunkIndex,
      sizeMB: (
        chunkBlob.size /
        (1024 * 1024)
      ).toFixed(2),
    }
  );

  try {
    const response = await UploadFile(
      "bot/recording/upload_chunk",
      formData,
      token
    );

    console.log(
      `✅ LIVE chunk ${chunkIndex + 1} uploaded`,
      response?.data
    );

    if (
      response?.status !== 200 ||
      response?.data?.success === false
    ) {
      throw new Error(
        response?.data?.message ||
          `Chunk ${chunkIndex} upload failed`
      );
    }

    return response;
  } catch (error) {
    console.error(
      `❌ LIVE chunk ${chunkIndex + 1} upload failed:`,
      error
    );

    throw error;
  }
};



// const uploadInChunks = async (
//   fileBlob,
//   uploadId,
//   interviewIdValue,
//   chunkSize = 10 * 1024 * 1024
// ) => {
//   const totalChunks = Math.max(
//     1,
//     Math.ceil(fileBlob.size / chunkSize)
//   );

//   console.log("🚀 Starting chunk upload:", {
//     uploadId,
//     interviewId: interviewIdValue,
//     videoSizeMB: (fileBlob.size / (1024 * 1024)).toFixed(2),
//     chunkSizeMB: (chunkSize / (1024 * 1024)).toFixed(2),
//     totalChunks,
//   });

//   /*
//    * Array.from + reduce is being used instead of for...of / for loop
//    * so ESLint no-restricted-syntax issue won't occur.
//    *
//    * reduce also uploads chunks SEQUENTIALLY:
//    * chunk 0 -> chunk 1 -> chunk 2...
//    */
//   const chunkIndexes = Array.from(
//     { length: totalChunks },
//     (_, index) => index
//   );

//   await chunkIndexes.reduce(
//     async (previousUpload, chunkIndex) => {
//       await previousUpload;

//       const start = chunkIndex * chunkSize;

//       const end = Math.min(
//         start + chunkSize,
//         fileBlob.size
//       );

//       const chunkBlob = fileBlob.slice(
//         start,
//         end,
//         "video/webm"
//       );

//       return uploadRecordingChunk({
//         chunkBlob,
//         uploadId,
//         chunkIndex,
//         totalChunks,
//       });
//     },
//     Promise.resolve()
//   );

//   console.log("✅ All chunks uploaded");

//   // All chunks successful -> merge + S3
//   const finalizeBody = {
//     uploadId,
//     totalChunks,
//     fileName: `${uploadId}.webm`,
//     interviewId: interviewIdValue,
//   };

//   console.log("🔗 Finalizing upload:", finalizeBody);

//   const finalizeResponse = await Api(
//     "bot/recording/finalize_upload",
//     "POST",
//     finalizeBody,
//     token
//   );

//   console.log(
//     "✅ Finalize response:",
//     finalizeResponse?.data
//   );

//   if (finalizeResponse?.data?.success === false) {
//     throw new Error(
//       finalizeResponse?.data?.message ||
//         "Video finalization failed"
//     );
//   }

//   return finalizeResponse?.data;
// };


const uploadRecording = async () => {
  console.log(
    "🚀 ===== FINALIZING LIVE RECORDING ====="
  );

  try {
    const interviewIdValue =
      interviewIdRef.current;

    const uploadId =
      uploadIdRef.current;

    if (!interviewIdValue) {
      throw new Error(
        "Interview ID not found"
      );
    }

    if (!uploadId) {
      throw new Error(
        "Recording upload ID not found"
      );
    }

    // ==========================================
    // STOP RECORDING
    //
    // This will:
    // 1. Stop MediaRecorder
    // 2. Upload final remaining chunk
    // 3. Wait for all chunk uploads
    // ==========================================
    await stopCameraRecording();

    // ==========================================
    // WAIT FOR EVERY CHUNK UPLOAD
    // ==========================================
    await uploadQueueRef.current;

    const totalChunks =
      uploadChunkIndexRef.current;

    console.log(
      "📊 LIVE recording upload complete:",
      {
        uploadId,
        interviewId:
          interviewIdValue,
        totalChunks,
      }
    );

    if (totalChunks === 0) {
      throw new Error(
        "No recording chunks were uploaded"
      );
    }

    // ==========================================
    // FINALIZE ONLY
    // ==========================================
    const finalizeBody = {
      uploadId,
      totalChunks,
      fileName:
        `${uploadId}.webm`,
      interviewId:
        interviewIdValue,
    };

    console.log(
      "🔗 Calling finalize_upload:",
      finalizeBody
    );

    const finalizeResponse =
      await Api(
        "bot/recording/finalize_upload",
        "POST",
        finalizeBody,
        token
      );

    console.log(
      "✅ Finalize response:",
      finalizeResponse?.data
    );

    if (
      finalizeResponse?.status !== 200 ||
      finalizeResponse?.data?.success === false
    ) {
      throw new Error(
        finalizeResponse?.data?.message ||
          "Video finalization failed"
      );
    }

    console.log(
      "🎉 VIDEO FINALIZED SUCCESSFULLY"
    );

    return finalizeResponse.data;
  } catch (error) {
    console.error(
      "❌ VIDEO FINALIZATION FAILED:",
      error
    );

    throw error;
  }
};

// const uploadRecording = async () => {
//   console.log("🚀 ===== STARTING UPLOAD =====");
  
//   const videoBlob = await stopCameraRecording();

//   if (!videoBlob) {
//     console.log("❌ No video blob to upload");
//     return;
//   }

//   console.log("📹 Video blob:", {
//     size: `${(videoBlob.size / 1024).toFixed(2)} KB`,
//     type: videoBlob.type,
//     isBlob: videoBlob instanceof Blob,
//   });

//   const formData = new FormData();
//   formData.append(
//     "video",
//     videoBlob,
//     `interview-${Date.now()}.webm` // Fixed: template literal instead of concatenation
//   );
//   formData.append("interviewId", interviewIdRef.current);

//   console.log("📋 InterviewId:", interviewIdRef.current);
//   console.log("📋 Token exists:", !!token);
//   console.log("📋 Token preview:", `${token?.substring(0, 30)}...`); // Fixed: template literal

//   // Debug: Check FormData contents - Fixed: use forEach instead of for...of
//   console.log("========== FORMDATA CONTENTS ==========");
//   const formDataObj = {};
//   formData.forEach((value, key) => { // Fixed: forEach with const parameters
//     if (value instanceof File) {
//       const fileInfo = {
//         name: value.name,
//         size: `${(value.size / 1024).toFixed(2)} KB`,
//         type: value.type,
//       };
//       console.log(`📦 ${key}:`, fileInfo);
//       formDataObj[key] = fileInfo;
//     } else {
//       console.log(`📦 ${key}:`, value);
//       formDataObj[key] = value;
//     }
//   });
//   console.log("📋 FormData summary:", formDataObj);
//   console.log("=======================================");

//   try {
//     console.log("📤 Calling UploadFile...");
    
//     const response = await UploadFile(
//       "bot/recording/upload_recording",
//       formData,
//       token
//     );

//     console.log("✅ Upload response:", response);
//     console.log("✅ Response status:", response?.status);
//     console.log("✅ Response data:", response?.data);
//     console.log("✅ Response success:", response?.data?.success);

//     if (response.status === 200 && response.data?.success) {
//       console.log("✅ Video uploaded successfully!");
//       // return response; // Fixed: return response on success
//     }
    
//     console.error("❌ Upload failed:", response);
//     // return response; // Fixed: return response on failure too

//   } catch (error) {
//     console.error("❌ Upload error:", error);
//     console.error("❌ Error message:", error.message);
//     console.error("❌ Error stack:", error.stack);
//     throw error;
//   }
// };

// const uploadRecording = async () => {
//   const videoBlob = await stopCameraRecording();

//   if (!videoBlob) return;

//   const formData = new FormData();

//   console.log("Video Recording::====>>>>>>>>>>>",formData)

//   formData.append(
//     "video",
//     videoBlob,
//     `interview-${Date.now()}.webm`
//   );

//   formData.append("interviewId", interviewIdRef.current);

//   await UploadFile("/api/interview/upload-video", {
//     method: "POST",
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//     body: formData,
//   });
// };

useEffect(() => {
  if (videoRef.current && videoStream) {
    videoRef.current.srcObject = videoStream;
  }
}, [videoStream]);

const isRepeatQuestionRequest = (text = "") => {
  const normalized = text
    .toLowerCase()
    .replace(/[^\w\s]/g, "")
    .trim();

  const repeatKeywords = [
    "repeat question",
    "please repeat question",
    "please repeat the question",
    "can you repeat question",
    "can you repeat the question",
    "could you repeat the question",
    "repeat it",
    // "repeat",
    "say that again",
    // "come again",
    // "pardon",
    "sorry repeat",
    "i didn't hear",
    "i did not hear",
    "what was the question",
    "question again",
    "can you say that again"
  ];

  return repeatKeywords.some(keyword => normalized.includes(keyword));
};

  // const submitCurrentAnswer = async () => {
  //   // Read LIVE values from refs, not from state closed over at mount time
  //   const question = currentQuestionRef.current;
  //   const id = interviewIdRef.current;

  //   if (!question || !id) return;

  //   setStatus("processing");
  //   const answerText = finalTranscriptRef.current.trim();
  //      if (!answerText) {
  //           handleNoResponse();
  //          return;
  //        }

  //      if (isRepeatQuestionRequest(answerText)) {
  //         noResponseCountRef.current = 0;
  //         setTranscriptPreview("");
  //         finalTranscriptRef.current = "";

  //        speakQuestion(currentQuestionRef.current.question);
  //        return;
  //       }  

  //   const body = {
  //     interviewId: id,
  //     questionId: question.questionId,
  //     answer: answerText,
  //   };

  //   try {
  //     await Api("bot/interview_session_submit_answer", "POST", body, token);

  //     // Candidate ne valid answer de diya,
  //     // no-response counter reset
  //     noResponseCountRef.current = 0;
  //     fetchNextQuestion(id);
  //   } catch (err) {
  //     setStatus("error");
  //     setErrorMessage("Could not submit answer.");
  //   }
  // };

//   const speakText = (text, callback) => {
//   const utterance = new SpeechSynthesisUtterance(text);

//   utterance.rate = 0.8;
//   utterance.pitch = 0.8;

//   utterance.onend = callback;
//   utterance.onerror = callback;

//   window.speechSynthesis.cancel();
//   window.speechSynthesis.speak(utterance);
// };


const submitValidatedAnswer = async (
  questionId,
  answerText
) => {
  const id = interviewIdRef.current;

  if (!id || !questionId || !answerText) {
    return;
  }

  try {
    await Api(
      "bot/interview_session_submit_answer",
      "POST",
      {
        interviewId: id,
        questionId,
        answer: answerText,
      },
      token
    );

    console.log("✅ Answer submitted");

    noResponseCountRef.current = 0;

    finalTranscriptRef.current = "";
    setTranscriptPreview("");

    fetchNextQuestion(id);
  } catch (err) {
    console.error(
      "Submit answer error:",
      err
    );

    setStatus("error");
    setErrorMessage(
      "Could not submit answer."
    );
  }
};


// const speakText = (text, callback) => {
//   if (!text) {
//     callback?.();
//     return;
//   }

//   // Stop previous speech
//   window.speechSynthesis.cancel();

//   const speak = () => {
//     const utterance = new SpeechSynthesisUtterance(text);

//     const voice =
//       selectedVoiceRef.current || loadBestVoice();

//     if (voice) {
//       utterance.voice = voice;
//       utterance.lang = voice.lang;
//     } else {
//       utterance.lang = "en-US";
//     }

//     // Natural sounding settings
//     utterance.rate = 0.88;
//     utterance.pitch = 1.0;
//     utterance.volume = 1.0;

//     utterance.onstart = () => {
//       setStatus("speaking");
//     };

//     utterance.onend = () => {
//       callback?.();
//     };

//     utterance.onerror = (event) => {
//       console.error("Speech error:", event);

//       callback?.();
//     };

//     window.speechSynthesis.speak(utterance);
//   };

//   // Sometimes Chrome needs a tiny delay after cancel()
//   setTimeout(speak, 50);
// };

// const speakText = (text, callback) => {
//   if (!text || !window.speechSynthesis) {
//     callback?.();
//     return;
//   }

//   const synth = window.speechSynthesis;

//   // Stop previous utterance
//   synth.cancel();

//   const speak = () => {
//     const voices = synth.getVoices();

//     console.log("Available voices:", voices);

//     let voice = selectedVoiceRef.current;

//     if (!voice && voices.length) {
//       voice =
//         voices.find(
//           (v) =>
//             v.name.toLowerCase().includes("jenny") &&
//             v.lang.toLowerCase().startsWith("en")
//         ) ||
//         voices.find(
//           (v) => v.lang === "en-US"
//         ) ||
//         voices.find(
//           (v) => v.lang.startsWith("en")
//         );

//       selectedVoiceRef.current = voice;
//     }

//     const utterance = new SpeechSynthesisUtterance(text);

//     if (voice) {
//       utterance.voice = voice;
//       utterance.lang = voice.lang;
//       console.log("🔊 Using voice:", voice.name, voice.lang);
//     } else {
//       utterance.lang = "en-US";
//       console.log("⚠️ No voice selected, using browser default");
//     }

//     utterance.rate = 0.88;
//     utterance.pitch = 1;
//     utterance.volume = 1;

//     utterance.onstart = () => {
//       console.log("🔊 Speech STARTED:", text);
//       setStatus("speaking");
//     };

//     utterance.onend = () => {
//       console.log("🔊 Speech ENDED");
//       callback?.();
//     };

//     utterance.onerror = (event) => {
//       console.error("❌ Speech synthesis error:", event);

//       // Important: continue interview even if TTS fails
//       callback?.();
//     };

//     synth.speak(utterance);

//     // Chrome sometimes pauses speech unexpectedly
//     setTimeout(() => {
//       if (synth.speaking && synth.paused) {
//         console.log("▶️ Resuming paused speech");
//         synth.resume();
//       }
//     }, 200);
//   };

//   // Voices may not be loaded yet
//   if (synth.getVoices().length === 0) {
//     console.log("⏳ Waiting for voices...");

//     const handleVoicesChanged = () => {
//       synth.removeEventListener(
//         "voiceschanged",
//         handleVoicesChanged
//       );

//       speak();
//     };

//     synth.addEventListener(
//       "voiceschanged",
//       handleVoicesChanged
//     );

//     // Fallback if voiceschanged doesn't fire
//     setTimeout(() => {
//       synth.removeEventListener(
//         "voiceschanged",
//         handleVoicesChanged
//       );

//       if (!synth.speaking) {
//         speak();
//       }
//     }, 500);

//     return;
//   }

//   // Small delay after cancel() helps Chrome
//   setTimeout(speak, 100);
// };

const speakText = (text, callback) => {
  if (!text || !window.speechSynthesis) {
    callback?.();
    return;
  }

  const synth = window.speechSynthesis;

  // Stop previous utterance
  synth.cancel();

  const speak = () => {
    const voices = synth.getVoices();

    let voice = selectedVoiceRef.current;

    if (!voice && voices.length) {
      voice =
        voices.find(
          (v) =>
            v.name.toLowerCase().includes("jenny") &&
            v.lang.toLowerCase().startsWith("en")
        ) ||
        voices.find(
          (v) => v.lang === "en-US"
        ) ||
        voices.find(
          (v) => v.lang.startsWith("en")
        );

      selectedVoiceRef.current = voice;
    }

    const utterance = new SpeechSynthesisUtterance(text);

    if (voice) {
      utterance.voice = voice;
      utterance.lang = voice.lang;
      console.log("🔊 Using voice:", voice.name, voice.lang);
    } else {
      utterance.lang = "en-US";
      console.log("⚠️ No voice selected, using browser default");
    }

    utterance.rate = 0.88;
    utterance.pitch = 1;
    utterance.volume = 1;

    utterance.onstart = () => {
      console.log("🔊 Speech STARTED:", text);
      setStatus("speaking");
    };

    utterance.onend = () => {
      console.log("🔊 Speech ENDED");
      callback?.();
      
      // ✅ MOBILE: Ensure listening restarts after speech
      if (isMobile && status !== "completed" && status !== "error") {
        console.log("📱 Mobile: Restarting listening after speech");
        setTimeout(() => {
          startListening();
        }, 300);
      }
    };

    utterance.onerror = (event) => {
      console.error("❌ Speech synthesis error:", event);
      callback?.();
      
      // ✅ MOBILE: Even on error, try to restart listening
      if (isMobile && status !== "completed" && status !== "error") {
        console.log("📱 Mobile: Restarting listening after speech error");
        setTimeout(() => {
          startListening();
        }, 500);
      }
    };

    synth.speak(utterance);
  };

  // Voices may not be loaded yet
  if (synth.getVoices().length === 0) {
    console.log("⏳ Waiting for voices...");

    const handleVoicesChanged = () => {
      synth.removeEventListener("voiceschanged", handleVoicesChanged);
      speak();
    };

    synth.addEventListener("voiceschanged", handleVoicesChanged);

    // Fallback
    setTimeout(() => {
      synth.removeEventListener("voiceschanged", handleVoicesChanged);
      if (!synth.speaking) {
        speak();
      }
    }, 500);

    return;
  }

  setTimeout(speak, 100);
};

// Add this helper after startListening function
const ensureListening = useCallback(() => {
  console.log("🔍 ensureListening called - isMobile:", isMobile, "status:", status);
  
  if (isMobile && (status === "listening" || status === "speaking")) {
    console.log("📱 Mobile: Ensuring listening is active");
    
    // Check if recognition is still active
    if (recognitionRef.current) {
      try {
        // If recognition exists but might be inactive, restart it
        console.log("🔄 Restarting recognition on mobile");
        recognitionRef.current.onend = null;
        recognitionRef.current.abort();
      } catch (e) {
        console.log("Recognition abort error:", e);
      }
      recognitionRef.current = null;
    }
    
    // Restart listening after short delay
    setTimeout(() => {
      if (status === "listening" || status === "speaking") {
        console.log("📱 Mobile: Starting listening again");
        startListening();
      }
    }, 300);
  }
}, [status, startListening]);

// const speakText = (text, callback) => {
//   if (!text || !window.speechSynthesis) {
//     callback?.();
//     return;
//   }

//   const synth = window.speechSynthesis;

//   // Stop previous utterance
//   synth.cancel();

//   const speak = () => {
//     const voices = synth.getVoices();

//     let voice = selectedVoiceRef.current;

//     if (!voice && voices.length) {
//       voice =
//         voices.find(
//           (v) =>
//             v.name.toLowerCase().includes("jenny") &&
//             v.lang.toLowerCase().startsWith("en")
//         ) ||
//         voices.find(
//           (v) => v.lang === "en-US"
//         ) ||
//         voices.find(
//           (v) => v.lang.startsWith("en")
//         );

//       selectedVoiceRef.current = voice;
//     }

//     const utterance = new SpeechSynthesisUtterance(text);

//     if (voice) {
//       utterance.voice = voice;
//       utterance.lang = voice.lang;
//       console.log("🔊 Using voice:", voice.name, voice.lang);
//     } else {
//       utterance.lang = "en-US";
//       console.log("⚠️ No voice selected, using browser default");
//     }

//     utterance.rate = 0.88;
//     utterance.pitch = 1;
//     utterance.volume = 1;

//     utterance.onstart = () => {
//       console.log("🔊 Speech STARTED:", text);
//       setStatus("speaking");
//     };

//     utterance.onend = () => {
//       console.log("🔊 Speech ENDED");
//       callback?.();
//     };

//     utterance.onerror = (event) => {
//       console.error("❌ Speech synthesis error:", event);
//       // callback?.();
//     };

//     synth.speak(utterance);
//   };

//   // Voices may not be loaded yet
//   if (synth.getVoices().length === 0) {
//     console.log("⏳ Waiting for voices...");

//     const handleVoicesChanged = () => {
//       synth.removeEventListener("voiceschanged", handleVoicesChanged);
//       speak();
//     };

//     synth.addEventListener("voiceschanged", handleVoicesChanged);

//     // Fallback
//     setTimeout(() => {
//       synth.removeEventListener("voiceschanged", handleVoicesChanged);
//       if (!synth.speaking) {
//         speak();
//       }
//     }, 500);

//     return;
//   }

//   setTimeout(speak, 100);
// };


// const handleNoResponse = () => {

//   noResponseCountRef.current += 1;

//   if (noResponseCountRef.current === 1) {

//     speakText(
//       "I am not getting any response. Do you want me to repeat the question?",
//       () => {

//         isRetryFlowRef.current = true;
//         startListening();

//       }
//     );

//     return;
//   }

//   if (noResponseCountRef.current === 2) {

//     speakText(
//       "I am still waiting to get the response from your side. Please respond to the question quickly.",
//       () => {

//         isRetryFlowRef.current = true;
//         startListening();

//       }
//     );

//     return;
//   }

//   speakText(
//     "I am unable to get response from your side. I will try to reschedule your interview, will connect back soon.",
//     () => {

//       // completeInterview(interviewIdRef.current);

//     }
//   );

// };

const handleNoResponse = () => {
  noResponseCountRef.current += 1;

  const id = interviewIdRef.current;
  const question = currentQuestionRef.current;

  if (!id || !question) {
    console.warn("Missing interview/question ID");
    return;
  }

  let botMessage = "";

  if (noResponseCountRef.current === 1) {
    botMessage =
      "I am not getting any response. Do you want me to repeat the question?";
  } else if (noResponseCountRef.current === 2) {
    botMessage =
      "I am still waiting to get the response from your side. Please respond to the question quickly.";
  } else {
    botMessage =
      "I am unable to get response from your side. I will try to reschedule your interview, will connect back soon.";
  }


    // For mobile, directly speak and listen again
  if (isMobile) {
    speakText(botMessage, () => {
      if (noResponseCountRef.current >= 3) {
        // End interview after 3 no-responses
        completeInterview(id);
        return;
      }
      // Restart listening
      setTimeout(() => {
        startListening();
      }, 500);
    });
    return;
  }

  const emitNoResponse = () => {
    setStatus("processing");

    console.log("📤 Sending no-response to socket:", {
      interviewId: id,
      questionId: '',
      question: botMessage,
      answerText: "",
      // noResponseCount: noResponseCountRef.current,
    });

    socket.emit("check_relevance", {
      interviewId: id,
      questionId: '',
      question: botMessage,
      answerText: "",
      noResponse: true,
      // noResponseCount: noResponseCountRef.current,
 
    });
  };

  if (!socket.connected) {
    console.warn("⚠️ Socket disconnected. Reconnecting...");

    setStatus("connecting");

    socket.once("connect", emitNoResponse);
    socket.connect();

    return;
  }

  emitNoResponse();
};




const completeInterview = async (id) => {
  setStatus("processing");

  const body = {
    interviewId: id,
  };

  try {
    // ==========================================
    // 1. COMPLETE INTERVIEW
    // ==========================================
    const res = await Api(
      "bot/interview_session_complete",
      "POST",
      body,
      token
    );

    const data = res.data;

    if (!data.success) {
      setStatus("error");
      setErrorMessage(data.message);
      return;
    }

    setFinalResult(data.data);

    // ==========================================
    // 2. STOP RECORDING + FINALIZE
    //
    // All previous chunks have already
    // been uploaded during recording.
    // ==========================================
    try {
      const uploadResult =
        await uploadRecording();

      console.log(
        "✅ Interview recording finalized:",
        uploadResult
      );
    } catch (uploadError) {
      console.error(
        "❌ Interview completed but recording finalization failed:",
        uploadError
      );

      // Decide according to your business logic
      // whether interview completion should
      // continue when recording fails.
    }

    // ==========================================
    // 3. INTERVIEW COMPLETED
    // ==========================================
    setStatus("completed");

    speakText(
      "That was the last question. Thank you for completing the interview. We'll be in touch soon with next steps."
    );

  } catch (err) {
    console.error(
      "Complete interview error:",
      err
    );

    setStatus("error");

    setErrorMessage(
      "Could not complete interview."
    );
  }
};


  // const completeInterview = async (id) => {
  //   setStatus("processing");

  //   const body = { interviewId: id };

  //   try {
  //     const res = await Api("bot/interview_session_complete", "POST", body, token);
  //     const data = await res.data;

  //     if (!data.success) {
  //       setStatus("error");
  //       setErrorMessage(data.message);
  //       return;
  //     }

  //     setFinalResult(data.data);
  //     setStatus("completed");


  //     speakText(
  //           "That was the last question. Thank you for completing the interview. We'll be in touch soon with next steps."
  //        );

  //     // const closing = new SpeechSynthesisUtterance(
  //     //   "That was the last question. Thank you for completing the interview. We'll be in touch soon with next steps."
  //     // );
  //     await uploadRecording();
  //     // window.speechSynthesis.speak(closing);
  //   } catch (err) {
  //     setStatus("error");
  //     setErrorMessage("Could not complete interview.");
  //   }
  // };



  const handleEndCall = () => {
    stopVoiceEngine();
    if (onEndCall) onEndCall();
  };

//   console.log(
//   window.speechSynthesis.getVoices().map(v => v.name)
// );

  return (

     <Box
  sx={{
    bgcolor: "#111827",
    color: "#fff",
    minHeight: "100vh",
    width: "100vw",
    position: "relative",
    overflow: "hidden",
  }}
   >

{/* {isMobile && (  */}
  {/* //    <Typography color="warning" sx={{ mb: 2 }}>
    //    ℹ️ For best experience, use headphones and allow microphone access
   //   </Typography>
  //  )} */}





{/* <Box
  sx={{
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    bgcolor: "#000",
    zIndex: 0,
  }}
> */}
  {/* Candidate Video - Full Screen */}
  {/* Bot Avatar - Floating Small Window (Bottom-Right) */}
{/* Candidate Full Screen Video */}
  {videoStream ? (
     <video
      ref={videoRef}
       autoPlay
      playsInline
      muted
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        backgroundColor: "#000",
      }} 
    />
  ) : (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#111827",
      }}
    >
      <Avatar
        sx={{
          width: 150,
          height: 150,
          fontSize: 50,
        }}
      >
        AI
      </Avatar>
    </Box>
  )}

  {/* Dark overlay */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(to bottom, rgba(0,0,0,0.6), transparent 30%, rgba(0,0,0,0.7))",
      pointerEvents: "none",
      // zIndex: 1,
    }}
  />

  {/* Top Bar */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      p: 3,
    }}
  >
    <Typography fontWeight={700}>
      {candidate?.company || "AI Interview"}
    </Typography>

    <Chip
      label={status.toUpperCase()}
      color={status === "listening" ? "success" : "primary"}
      variant="filled"
    />
  </Box>

  {/* Center Content */}
  <Box
    sx={{
      position: "absolute",
      zIndex: 2,
      left: 0,
      right: 0,
      bottom: 120,
      px: 3,
      textAlign: "center",
    }}
  >
    <Typography
      variant="body1"
      color="#93c5fd"
      mb={2}
      fontWeight={500}
    >
      {status === "connecting" && "Connecting to interview..."}
      {status === "greeting" && "Bot is introducing itself..."}
      {status === "processing" && "Processing, please wait..."}
      {status === "speaking" && "Bot is asking a question..."}
      {status === "listening" && "Listening to your answer..."}
      {status === "completed" && "Interview Completed"}
      {status === "error" && "Error Encountered"}
    </Typography>

{/* {!isInterviewStarted && (status === "greeting" || status === "connecting") && (
  <Box sx={{ mt: 3 }}>
    <Button
      variant="contained"
      color="primary"
      onClick={handleStartInterview}
      sx={{ fontSize: '1.2rem', py: 2, px: 4 }}
    >
      Tap to Start Interview
    </Button>
    <Typography variant="caption" color="gray" sx={{ display: 'block', mt: 1 }}>
      Required to enable microphone access
    </Typography>
  </Box>
)} */}

    {currentQuestion && status !== "completed" && (
      <Box
        sx={{
          maxWidth: 900,
          mx: "auto",
          p: 3,
          borderRadius: 3,
          backgroundColor: "rgba(0,0,0,0.55)",
          backdropFilter: "blur(8px)",
        }}
      >
        <Typography variant="caption" color="#d1d5db">
          Question {progress.answered + 1} of {progress.total} (
          {currentQuestion.questionType})
        </Typography>

        <Typography
          variant="h5"
          color='#fff'
          fontWeight={600}
          mt={1}
        >
          {currentQuestion.question}
        </Typography>
      </Box>
    )}




{conversationHistory.length > 0 && (
  <Box sx={{ mt: 3, maxHeight: 200, overflowY: 'auto' }}>
    {conversationHistory.map((item, index) => (
      <Box key={index} sx={{ 
        p: 1, 
        mb: 1, 
        bgcolor: item.role === 'candidate' ? 'rgba(59,130,246,0.2)' : 'rgba(75,85,99,0.3)',
        borderRadius: 1,
        textAlign: 'left'
      }}>
        <Typography variant="caption" color="gray.500">
          {item.role === 'candidate' ? 'You' : 'Interviewer'}:
        </Typography>
        <Typography variant="body2">{item.content}</Typography>
      </Box>
    ))}
  </Box>
)}

    {status === "listening" && (
      <Box
        sx={{
          maxWidth: 300,
          mx: "auto",
          bgcolor: "rgba(31,41,55,0.85)",
          p: 2,
          borderRadius: 2,
          mt: 2,
          border: "1px dashed #4b5563",
          backdropFilter: "blur(8px)",
        }}
      >
        <Typography variant="caption" color="#6ee7b7">
          Speak Now
        </Typography>

        {/* <Typography
          variant="body2"
          color="#e5e7eb"
          mt={0.5}
        >
          {transcriptPreview || "Speak now..."}
        </Typography> */}
      </Box>
    )}

    {status === "completed" && finalResult && (
      <Box sx={{ my: 3 }}>
        <Typography
          variant="h4"
          color="#4ade80"
          fontWeight={700}
        >
          Score: {finalResult.overallScore}/100
        </Typography>

        <Typography
          variant="body2"
          color="white"
          mt={1}
        >
          {finalResult.scoreSummary}
        </Typography>
      </Box>
    )}

    {status === "error" && (
      <Typography color="error" mt={2}>
        {errorMessage}
      </Typography>
    )}
  </Box>

  {/* End Call Button */}
  <Stack
    direction="row"
    justifyContent="center"
    sx={{
      position: "absolute",
      bottom: 30,
      left: 0,
      right: 0,
      zIndex: 3,
    }}
  >
    <IconButton
      onClick={handleEndCall}
      sx={{
        bgcolor: "#d93025",
        color: "#fff",
        width: 64,
        height: 64,
        "&:hover": {
          bgcolor: "#c62828",
        },
      }}
    >
      <CallEndIcon fontSize="large" />
    </IconButton>
  </Stack>
</Box>


    // <Box
    //   sx={{
    //     bgcolor: "#111827",
    //     color: "#fff",
    //     minHeight: "100vh",
    //     display: "flex",
    //     flexDirection: "column",
    //     justifyContent: "space-between",
    //     alignItems: "center",
    //     p: 3,
    //     position: "relative",
    //   }}
    // >
    //   <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //     <Typography variant="h6" fontWeight={700}>
    //       {candidate?.company || "AI Interview"}
    //     </Typography>
    //     <Chip
    //       label={status.toUpperCase()}
    //       color={status === "listening" ? "success" : "primary"}
    //       variant="filled"
    //     />
    //   </Box>

    //   <Container maxWidth="sm" sx={{ textAlign: "center", my: "auto" }}>

    //   {videoStream ? (
    //    <video
    //      ref={videoRef}
    //      autoPlay
    //      playsInline
    //      muted
    //      style={{
    //        width: 220,
    //        height: 220,
    //        borderRadius: "50%",
    //        objectFit: "cover",
    //       }}
    //       />
    //   ) : (
    //     <Avatar>AI</Avatar>
    //    )}
    //     <Typography variant="body1" color="#93c5fd" mb={2} fontWeight={500}>
    //       {status === "connecting" && "Connecting to interview..."}
    //       {status === "greeting" && "Bot is introducing itself..."}
    //       {status === "processing" && "Processing, please wait..."}
    //       {status === "speaking" && "Bot is asking a question..."}
    //       {status === "listening" && "Listening to your answer..."}
    //       {status === "completed" && "Interview Completed"}
    //       {status === "error" && "Error Encountered"}
    //     </Typography>

    //     {currentQuestion && status !== "completed" && (
    //       <Box sx={{ my: 3 }}>
    //         <Typography variant="caption" color="gray">
    //           Question {progress.answered + 1} of {progress.total} (
    //           {currentQuestion.questionType})
    //         </Typography>
    //         <Typography variant="h5" fontWeight={600} mt={1}>
    //           {currentQuestion.question}
    //         </Typography>
    //       </Box>
    //     )}

    //     {status === "listening" && (
    //       <Box
    //         sx={{
    //           bgcolor: "#1f2937",
    //           p: 2,
    //           borderRadius: 2,
    //           mt: 2,
    //           border: "1px dashed #4b5563",
    //         }}
    //       >
    //         <Typography variant="caption" color="#6ee7b7">
    //           Live Transcript
    //         </Typography>
    //         <Typography variant="body2" color="#e5e7eb" mt={0.5}>
    //           {transcriptPreview || "Speak now..."}
    //         </Typography>
    //       </Box>
    //     )}

    //     {status === "completed" && finalResult && (
    //       <Box sx={{ my: 3 }}>
    //         <Typography variant="h4" color="#4ade80" fontWeight={700}>
    //           Score: {finalResult.overallScore}/100
    //         </Typography>
    //         <Typography variant="body2" color="gray" mt={1}>
    //           {finalResult.scoreSummary}
    //         </Typography>
    //       </Box>
    //     )}

    //     {status === "error" && (
    //       <Typography color="error" mt={2}>
    //         {errorMessage}
    //       </Typography>
    //     )}
    //   </Container>

    //   <Stack direction="row" spacing={2} justifyContent="center" sx={{ pb: 2 }}>
    //     <IconButton
    //       onClick={handleEndCall}
    //       sx={{
    //         bgcolor: "#d93025",
    //         color: "#fff",
    //         width: 64,
    //         height: 64,
    //         "&:hover": { bgcolor: "#c62828" },
    //       }}
    //     >
    //       <CallEndIcon fontSize="large" />
    //     </IconButton>
    //   </Stack>
    // </Box>
  );
}

// ==========================================
// 2. Preview Panel (Lobby)
// ==========================================
function PreviewPanel({ permissions, setPermissions, candidate, requestMedia, setRecordingId }) {
  const toggleMic = () => setPermissions((prev) => ({ ...prev, microphone: !prev.microphone }));
  const toggleCamera = () => setPermissions((prev) => ({ ...prev, camera: !prev.camera }));
  const toggleScreen = () => setPermissions((prev) => ({ ...prev, screen: !prev.screen }));

  // const [recordingId, setRecordingId] = useState('');

   const [searchParams] = useSearchParams();

  // const jobTitle = searchParams.get("jobTitle") || "";
  const clientName = searchParams.get("clientName") || "";
  // const fullName = searchParams.get("fullName") || "";
  // const time = searchParams.get("time") || "";
  // const timezone = searchParams.get("timezone") || "";
  const interviewId = searchParams.get("interviewId");
  const token = searchParams.get("token") || "";
  const adminName = searchParams.get("adminName")

  const initiateRecording = async () => {

  // const id = interviewIdRef.current;

  const body = {
     interviewId,
  };

  try {
    const res = await Api(
      "bot/recording/initiate",
      "POST",
      body,
      token
    );

    const data = await res.data;

    if (!data.success) {
      console.error(
        "❌ Recording initiation failed:",
        data.message
      );

      return null;
    }
    setRecordingId(res.data.data.recordingId);
    console.log(
      "✅ Recording initiated:",
      data.data
    );
    console.log("Recordingid::: ",res.data.data.recordingId)
    return data.data;
  } catch (err) {
    console.error(
      "❌ Recording initiate API error:",
      err
    );

    return null;
  }
};


  return (
    <Box
      sx={{
        bgcolor: "#1f1f1f",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        height: 650,
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Avatar sx={{ width: 110, height: 110, bgcolor: "#1976d2", fontSize: 40 }}>
          {candidate.name ? candidate.name[0] : "C"}
        </Avatar>

        <Typography mt={3} color="white" fontSize={28} fontWeight={700}>
          {candidate.name}
        </Typography>

        <Typography color="#cfcfcf">Screen Preview</Typography>

        <Typography mt={2} color="#7cff7c">
          Ready for Interview
        </Typography>
      </Box>

      <Stack
        direction="row"
        spacing={3}
        justifyContent="center"
        sx={{ position: "absolute", bottom: 25, width: "100%" }}
      >
        <IconButton
          // onClick={async () => {
          //   await requestMedia();
          //   toggleMic()
          //  }}
           onClick={() => requestMedia("microphone")}
          sx={{
            bgcolor: permissions.microphone ? "#34A853" : "#d93025",
            color: "#fff",
            width: 58,
            height: 58,
            "&:hover": { bgcolor: permissions.microphone ? "#2d9448" : "#c62828" },
          }}
        >
          {permissions.microphone ? <MicIcon /> : <MicOffIcon />}
        </IconButton>

        <IconButton
          // onClick={async () => {
          //   await requestMedia();
          //   toggleCamera()
          // }}
          onClick={() => { requestMedia("camera")
            initiateRecording()
          }}
          sx={{
            bgcolor: permissions.camera ? "#34A853" : "#d93025",
            color: "#fff",
            width: 58,
            height: 58,
            "&:hover": { bgcolor: permissions.camera ? "#2d9448" : "#c62828" },
          }}
        >
          {permissions.camera ? <VideocamIcon /> : <VideocamOffIcon />}
        </IconButton>

        <IconButton
          onClick={toggleScreen}
          sx={{
            bgcolor: permissions.screen ? "#34A853" : "#d93025",
            color: "#fff",
            width: 58,
            height: 58,
            "&:hover": { bgcolor: permissions.screen ? "#2d9448" : "#c62828" },
          }}
        >
          {permissions.screen ? <ScreenShareIcon /> : <StopScreenShareIcon />}
        </IconButton>

        <IconButton
          sx={{
            bgcolor: "#3c4043",
            color: "#fff",
            width: 58,
            height: 58,
            "&:hover": { bgcolor: "#5f6368" },
          }}
        >
          <SettingsIcon />
        </IconButton>
      </Stack>
    </Box>
  );
}

// ==========================================
// 3. Join Panel (Lobby)
// ==========================================
function JoinPanel({ candidate, permissions, onJoin }) {
  const allGranted = permissions.microphone &&
   permissions.camera &&
    permissions.screen;

  return (
    <Card elevation={3} sx={{ borderRadius: 4, height: "100%" }}>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h5" fontWeight={700}>
          Ready to Join
        </Typography>

        <Typography color="text.secondary" mt={1}>
          Verify your details before joining the interview.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Stack spacing={2}>
          <Stack direction="row" spacing={2} alignItems="center">
            <PersonIcon color="primary" />
            <Box>
              <Typography fontWeight={600}>Candidate</Typography>
              <Typography color="text.secondary">{candidate.name}</Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <BusinessIcon color="primary" />
            <Box>
              <Typography fontWeight={600}>Company</Typography>
              <Typography color="text.secondary">{candidate.company}</Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <AccessTimeIcon color="primary" />
            <Box>
              <Typography fontWeight={600}>Interview</Typography>
              <Typography color="text.secondary">{candidate.interviewTime}</Typography>
              <Typography color="text.secondary">{candidate.duration}</Typography>
            </Box>
          </Stack>
        </Stack>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" fontWeight={700} mb={2}>
          Permission Status
        </Typography>

        <Chip
          icon={allGranted ? <CheckCircleIcon /> : <CancelIcon />}
          color={allGranted ? "success" : "warning"}
          label={allGranted ? "Ready to Join" : "Permissions Pending"}
          sx={{ width: "100%", height: 45, fontWeight: 600 }}
        />

        <Button
          fullWidth
          size="large"
          variant="contained"
          disabled={!allGranted}
          onClick={onJoin}
          sx={{
            mt: 4,
            height: 56,
            borderRadius: 3,
            fontSize: 16,
            textTransform: "none",
            fontWeight: 700,
          }}
        >
          Join Interview
        </Button>

        {!allGranted && (
          <Typography mt={2} color="error" fontSize={13} textAlign="center">
            Please allow Camera, Microphone and Screen Sharing.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

// ==========================================
// 4. Page Wrapper — ties lobby + call together
// ==========================================
export default function InterviewSessionPage() {
  const [searchParams] = useSearchParams();

  const jobTitle = searchParams.get("jobTitle") || "";
  const clientName = searchParams.get("clientName") || "";
  const fullName = searchParams.get("fullName") || "";
  const time = searchParams.get("time") || "";
  const timezone = searchParams.get("timezone") || "";
  const interviewToken = searchParams.get("interviewToken") || "";
  const token = searchParams.get("token") || "";

  const candidate = {
    name: fullName,
    company: clientName,
    interviewTime: time,
    duration: timezone ? `Time Zone: ${timezone}` : "",
    jobTitle,
  };

  const [permissions, setPermissions] = useState({
    microphone: false,
    camera: false,
    screen: false,
  });

  const [inCall, setInCall] = useState(false);
  const [recordingId, setRecordingId] = useState(null);

  // Request actual browser mic/camera permissions when toggled on

const requestMedia = async (type) => {
  try {
    if (type === "microphone" && !permissions.microphone) {
      try {
        const micStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });

        console.log("✅ Microphone available");

        micStream.getTracks().forEach((track) => track.stop());

        // Permission successfully granted
        setPermissions((prev) => ({
          ...prev,
          microphone: true,
        }));
      } catch (err) {
        console.error("❌ Microphone failed:", err.name, err.message);

        setPermissions((prev) => ({
          ...prev,
          microphone: false,
        }));
      }
    }

    if (type === "camera" && !permissions.camera) {
      try {
        const cameraStream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });

        console.log("✅ Camera available");
        console.log("Camera tracks:", cameraStream.getVideoTracks());

        cameraStream.getTracks().forEach((track) => track.stop());

        // Permission successfully granted
        setPermissions((prev) => ({
          ...prev,
          camera: true,
        }));
      } catch (err) {
        console.error("❌ Camera failed:", err.name, err.message);

        setPermissions((prev) => ({
          ...prev,
          camera: false,
        }));
      }
    }
  } catch (err) {
    console.error("Media error:", err);
  }
};

//   const requestMedia = async () => {
//     try {
//       console.log("Mic:", permissions.microphone);
//       console.log("Camera:", permissions.camera);

//       if (!permissions.microphone) {
//         try {
//           const micStream = await navigator.mediaDevices.getUserMedia({
//             audio: true,
//             video: false,
//           });

//           console.log("✅ Microphone available");
//           micStream.getTracks().forEach((track) => track.stop());
//         } catch (err) {
//           console.error("❌ Microphone failed:", err.name, err.message);
//         }
//       }
// console.log('permission.camera DATA::',permissions.camera);
//       if (!permissions.camera) {
//         try {
//          const stream = await navigator.mediaDevices.getUserMedia({
//             audio: false,
//             video: true,
//           });

//           console.log("✅ Camera available");
//           console.log("Camera tracks:", stream.getVideoTracks());
//         } catch (err) {
//           console.error("❌ Camera failed:", err);
//         }
//       }
//     } catch (err) {
//       console.error("Media error:", err);
//     }
//   };

  

 

  // useEffect(() => {
  //   let stream;

  //   const requestMedia = async () => {
  //     if (!permissions.microphone && !permissions.camera) return;

  //     try {
  //       stream = await navigator.mediaDevices.getUserMedia({
  //         audio: permissions.microphone,
  //         video: permissions.camera,
  //       });
  //     } catch (err) {
  //       console.log("Media permission error:", err);
  //       setPermissions((prev) => ({ ...prev, microphone: false, camera: false }));
  //     }
  //   };

  //   requestMedia();

  //   return () => {
  //     if (stream) {
  //       stream.getTracks().forEach((track) => track.stop());
  //     }
  //   };
  // }, [permissions.microphone, permissions.camera]);

  const handleJoin = () => {
    setInCall(true);
  };

  const handleEndCall = () => {
    setInCall(false);
  };

  if (inCall) {
    return (
      <VoiceInterview
        candidate={candidate}
        interviewToken={interviewToken}
        token={token}
        recordingId={recordingId}
        onEndCall={handleEndCall}
      />
    );
  }

  return (
    <Box sx={{ bgcolor: "#0f0f0f", minHeight: "100vh", p: 4 }}>
      <Grid container spacing={4} sx={{ maxWidth: 1200, mx: "auto" }}>
        <Grid item xs={12} md={7}>
          <PreviewPanel
            permissions={permissions}
            setPermissions={setPermissions}
            candidate={candidate}
            requestMedia={requestMedia}
            setRecordingId={setRecordingId}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <JoinPanel
            candidate={candidate}
            permissions={permissions}
            onJoin={handleJoin}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// ==========================================
// 4. Main Export Component
// ==========================================
// export default function InterviewLobby() {
//   const [searchParams] = useSearchParams();

//   const jobTitle = searchParams.get("jobTitle");
//   const clientName = searchParams.get("clientName");
//   const fullName = searchParams.get("fullName");
//   const time = searchParams.get("time");
//   const timezone = searchParams.get("timezone");
//   const interviewToken = searchParams.get("interviewToken");
//   const token = searchParams.get("token");
//   const interviewId = searchParams.get("interviewId")

//   const [isMeetingStarted, setIsMeetingStarted] = useState(false);

//   const [permissions, setPermissions] = useState({
//     microphone: false,
//     camera: false,
//     screen: false,
//   });

//   const candidate = {
//     name: fullName || "Candidate",
//     position: jobTitle || "Role",
//     company: clientName || "Company",
//     interviewTime: `${time || ""} (${timezone || ""})`,
//     duration: "30 Minutes",
//   };

//   // Switch to Voice Interview Screen
//   if (isMeetingStarted) {
//     return (
//       <VoiceInterview
//         interviewToken={interviewToken}
//         candidate={candidate}
//         onEndCall={() => setIsMeetingStarted(false)}
//       />
//     );
//   }

//   // Render Lobby Screen
//   return (
//     <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>
//       <AppBar
//         elevation={0}
//         position="static"
//         sx={{ bgcolor: "#fff", color: "#000", borderBottom: "1px solid #eee" }}
//       >
//         <Toolbar>
//           <Typography variant="h5" sx={{ fontWeight: 700 }}>
//             AI Interview
//           </Typography>
//           <Box sx={{ flexGrow: 1 }} />
//           <Typography sx={{ mr: 2, color: "#555" }}>
//             {candidate.company}
//           </Typography>
//           <Avatar>R</Avatar>
//         </Toolbar>
//       </AppBar>

//       <Box sx={{ p: 4 }}>
//         <Grid container spacing={4}>
//           <Grid item xs={12} md={8}>
//             <PreviewPanel
//               permissions={permissions}
//               setPermissions={setPermissions}
//               candidate={candidate}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <JoinPanel
//               permissions={permissions}
//               candidate={candidate}
//               onJoin={() => setIsMeetingStarted(true)}
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>
//   );
// }



// import React, { useState, useEffect, useRef, useCallback } from "react";

// /**
//  * Voice-driven AI Interview component (Browser Web Speech API — Chrome/Edge).
//  *
//  * Flow, fully automatic, no buttons:
//  * 1. Join session
//  * 2. Bot speaks an intro greeting ("Hello, I'm your AI interview assistant...")
//  * 3. Fetch first question -> bot speaks it (SpeechSynthesis)
//  * 4. After bot finishes speaking -> start listening (SpeechRecognition)
//  * 5. Silence detected -> stop listening -> submit answer
//  * 6. Fetch next question -> repeat from step 3
//  * 7. No more questions -> complete + score + closing line
//  */
// import { Api, UploadFile } from '../webservices';
// // const API_BASE = "http://ec2-3-111-181-217.ap-south-1.compute.amazonaws.com:8000/bot"; // set your real backend URL

// const SILENCE_TIMEOUT_MS = 2500;

// export default function VoiceInterview({ interviewToken }) {
//   const [status, setStatus] = useState("connecting"); // connecting | greeting | speaking | listening | processing | completed | error
//   const [interviewId, setInterviewId] = useState(null);
//   const [candidateName, setCandidateName] = useState("");
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [transcriptPreview, setTranscriptPreview] = useState("");
//   const [progress, setProgress] = useState({ answered: 0, total: 0 });
//   const [finalResult, setFinalResult] = useState(null);
//   const [errorMessage, setErrorMessage] = useState("");

//   const recognitionRef = useRef(null);
//   const silenceTimerRef = useRef(null);
//   const finalTranscriptRef = useRef("");

//   // =============================
//   // Step 1: Join session on mount
//   // =============================

//   useEffect(() => {
//     joinSession();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const joinSession = async () => {
//     const body = {
//       interviewToken,
//     }

//      const token = localStorage.getItem('token');
//     try {
//       const res = await Api(`bot/schedule_interview`, "POST", body, token );
//       const data = await res.json();

//       if (!data.success) {
//         setStatus("error");
//         setErrorMessage(data.message);
//         return;
//       }

//       setInterviewId(data.data.interviewId);
//       setCandidateName(data.data.candidateName || "");
//       setProgress({ answered: 0, total: data.data.totalQuestions });

//       // Speak the intro greeting before asking the first question
//       speakIntroGreeting(data.data.candidateName, data.data.interviewId);
//     } catch (err) {
//       setStatus("error");
//       setErrorMessage("Could not connect to interview server.");
//     }
//   };

//   // =============================
//   // Step 2: Bot speaks an intro greeting, then moves to first question
//   // =============================

//   const speakIntroGreeting = (name, id) => {
//     setStatus("greeting");

//     const firstName = name ? name.split(" ")[0] : "";
//     const greetingText = firstName
//       ? `Hello ${firstName}, I'm your AI interview assistant. I'll be asking you a few questions today. Please answer each question after you hear it, and pause when you're done speaking. Let's get started.`
//       : `Hello, I'm your AI interview assistant. I'll be asking you a few questions today. Please answer each question after you hear it, and pause when you're done speaking. Let's get started.`;

//     const utterance = new SpeechSynthesisUtterance(greetingText);
//     utterance.rate = 1;
//     utterance.pitch = 1;

//     utterance.onend = () => {
//       fetchNextQuestion(id);
//     };

//     utterance.onerror = () => {
//       fetchNextQuestion(id);
//     };

//     window.speechSynthesis.cancel();
//     window.speechSynthesis.speak(utterance);
//   };

//   // =============================
//   // Step 3: Fetch next question, then speak it
//   // =============================

//   const fetchNextQuestion = async (id) => {
//     setStatus("processing");
//     try {
//       const res = await Api(`bot/interview_session_next_question`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ interviewId: id }),
//       });
//       const data = await res.json();

//       if (!data.success) {
//         setStatus("error");
//         setErrorMessage(data.message);
//         return;
//       }

//       setProgress({
//         answered: data.data.answeredCount,
//         total: data.data.totalQuestions,
//       });

//       if (data.data.completed) {
//         completeInterview(id);
//         return;
//       }

//       setCurrentQuestion(data.data.question);
//       speakQuestion(data.data.question.question);
//     } catch (err) {
//       setStatus("error");
//       setErrorMessage("Could not fetch next question.");
//     }
//   };

//   // =============================
//   // Step 4: Bot speaks the question (browser TTS)
//   // =============================

//   const speakQuestion = (text) => {
//     setStatus("speaking");
//     setTranscriptPreview("");

//     const utterance = new SpeechSynthesisUtterance(text);
//     utterance.rate = 1;
//     utterance.pitch = 1;

//     utterance.onend = () => {
//       startListening();
//     };

//     utterance.onerror = () => {
//       startListening();
//     };

//     window.speechSynthesis.cancel();
//     window.speechSynthesis.speak(utterance);
//   };

//   // =============================
//   // Step 5: Listen for candidate's spoken answer (browser STT)
//   // =============================

//   const startListening = useCallback(() => {
//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;

//     if (!SpeechRecognition) {
//       setStatus("error");
//       setErrorMessage("Voice recognition is not supported in this browser. Please use Chrome or Edge.");
//       return;
//     }

//     setStatus("listening");
//     finalTranscriptRef.current = "";

//     const recognition = new SpeechRecognition();
//     recognition.continuous = true;
//     recognition.interimResults = true;
//     recognition.lang = "en-US";

//     recognition.onresult = (event) => {
//       let interim = "";

//     for (let i = event.resultIndex; i < event.results.length; i += 1) {
//   const chunk = event.results[i][0].transcript;

//   if (event.results[i].isFinal) {
//     finalTranscriptRef.current += `${chunk} `;
//   } else {
//     interim += chunk;
//   }
// }

//       setTranscriptPreview((finalTranscriptRef.current + interim).trim());
//       resetSilenceTimer();
//     };

//     recognition.onerror = (event) => {
//       if (event.error !== "no-speech") {
//         console.log("Speech recognition error:", event.error);
//       }
//     };

//     recognition.onend = () => {
//       if (silenceTimerRef.current) {
//         clearTimeout(silenceTimerRef.current);
//       }
//       submitCurrentAnswer();
//     };

//     recognitionRef.current = recognition;
//     recognition.start();
//     resetSilenceTimer();
//   }, []);

//   const resetSilenceTimer = () => {
//     if (silenceTimerRef.current) {
//       clearTimeout(silenceTimerRef.current);
//     }

//     silenceTimerRef.current = setTimeout(() => {
//       if (recognitionRef.current) {
//         recognitionRef.current.stop();
//       }
//     }, SILENCE_TIMEOUT_MS);
//   };

//   // =============================
//   // Step 6: Submit the captured answer, then fetch next question
//   // =============================

//   const submitCurrentAnswer = async () => {
//     if (!currentQuestion || !interviewId) return;

//     setStatus("processing");

//     const answerText = finalTranscriptRef.current.trim();

//     try {
//       await Api(`bot/interview_session_submit_answer`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           interviewId,
//           questionId: currentQuestion.questionId,
//           answer: answerText,
//         }),
//       });

//       fetchNextQuestion(interviewId);
//     } catch (err) {
//       setStatus("error");
//       setErrorMessage("Could not submit answer.");
//     }
//   };

//   // =============================
//   // Step 7: Complete + score interview
//   // =============================

//   const completeInterview = async (id) => {
//     setStatus("processing");
//     try {
//       const res = await Api(`bot/interview_session_complete`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ interviewId: id }),
//       });
//       const data = await res.json();

//       if (!data.success) {
//         setStatus("error");
//         setErrorMessage(data.message);
//         return;
//       }

//       setFinalResult(data.data);
//       setStatus("completed");

//       const closing = new SpeechSynthesisUtterance(
//         "That was the last question. Thank you for completing the interview. We'll be in touch soon with next steps."
//       );
//       window.speechSynthesis.speak(closing);
//     } catch (err) {
//       setStatus("error");
//       setErrorMessage("Could not complete interview.");
//     }
//   };

//   // =============================
//   // Cleanup on unmount
//   // =============================

//   useEffect(() => {
//     return () => {
//       if (recognitionRef.current) recognitionRef.current.stop();
//       if (silenceTimerRef.current) clearTimeout(silenceTimerRef.current);
//       window.speechSynthesis.cancel();
//     };
//   }, []);

//   // =============================
//   // UI
//   // =============================

//   return (
//     <div style={styles.container}>
//       <div style={styles.avatarCircle}>
//         <span style={styles.avatarInitial}>AI</span>
//       </div>

//       <div style={styles.statusText}>
//         {status === "connecting" && "Connecting to interview..."}
//         {status === "greeting" && "Bot is introducing itself..."}
//         {status === "processing" && "Please wait..."}
//         {status === "speaking" && "Bot is asking a question..."}
//         {status === "listening" && "Listening for your answer..."}
//         {status === "completed" && "Interview completed"}
//         {status === "error" && "Something went wrong"}
//       </div>

//       {currentQuestion && status !== "completed" && (
//         <div style={styles.questionBox}>
//           <p style={styles.questionLabel}>
//             Question {progress.answered + 1} of {progress.total} ({currentQuestion.questionType})
//           </p>
//           <p style={styles.questionText}>{currentQuestion.question}</p>
//         </div>
//       )}

//       {status === "listening" && (
//         <div style={styles.transcriptBox}>
//           <p style={styles.transcriptLabel}>Listening...</p>
//           <p style={styles.transcriptText}>{transcriptPreview || "..."}</p>
//         </div>
//       )}

//       {status === "completed" && finalResult && (
//         <div style={styles.resultBox}>
//           <p style={styles.resultScore}>Score: {finalResult.overallScore}/100</p>
//           <p style={styles.resultSummary}>{finalResult.scoreSummary}</p>
//         </div>
//       )}

//       {status === "error" && (
//         <div style={styles.errorBox}>
//           <p>{errorMessage}</p>
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     minHeight: "500px",
//     backgroundColor: "#111827",
//     color: "#fff",
//     borderRadius: "8px",
//     padding: "40px 20px",
//     fontFamily: "system-ui, sans-serif",
//   },
//   avatarCircle: {
//     width: "120px",
//     height: "120px",
//     borderRadius: "50%",
//     backgroundColor: "#2563eb",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     marginBottom: "20px",
//   },
//   avatarInitial: { fontSize: "36px", fontWeight: "bold" },
//   statusText: { fontSize: "16px", color: "#93c5fd", marginBottom: "24px" },
//   questionBox: { maxWidth: "600px", textAlign: "center", marginBottom: "24px" },
//   questionLabel: { fontSize: "13px", color: "#9ca3af", marginBottom: "8px" },
//   questionText: { fontSize: "20px", fontWeight: "600" },
//   transcriptBox: {
//     maxWidth: "600px",
//     textAlign: "center",
//     backgroundColor: "#1f2937",
//     borderRadius: "8px",
//     padding: "16px 24px",
//   },
//   transcriptLabel: { fontSize: "12px", color: "#6ee7b7", marginBottom: "6px" },
//   transcriptText: { fontSize: "16px", color: "#e5e7eb", minHeight: "24px" },
//   resultBox: { textAlign: "center" },
//   resultScore: { fontSize: "28px", fontWeight: "bold", color: "#4ade80", marginBottom: "12px" },
//   resultSummary: { fontSize: "15px", color: "#d1d5db", maxWidth: "500px" },
//   errorBox: { color: "#f87171", textAlign: "center" },
// };



// import React, { useState } from "react";
// import {
//   Box,
//   Grid,
//   AppBar,
//   Toolbar,
//   Typography,
//   Avatar,
//   Button,
//   Stack,
//   IconButton,
//   Card,
//   CardContent,
//   Divider,
//   Chip,
// } from "@mui/material";

// // Icons Imports
// import MicIcon from "@mui/icons-material/Mic";
// import MicOffIcon from "@mui/icons-material/MicOff";
// import VideocamIcon from "@mui/icons-material/Videocam";
// import VideocamOffIcon from "@mui/icons-material/VideocamOff";
// import ScreenShareIcon from "@mui/icons-material/ScreenShare";
// import StopScreenShareIcon from "@mui/icons-material/StopScreenShare";
// import SettingsIcon from "@mui/icons-material/Settings";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import BusinessIcon from "@mui/icons-material/Business";
// import PersonIcon from "@mui/icons-material/Person";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useSearchParams } from "react-router-dom";

// // ==========================================
// // 1. PermissionStatus Component (Helper)
// // ==========================================
// // const PermissionItem = ({ title, status }) => (
// //   <Stack
// //     direction="row"
// //     alignItems="center"
// //     justifyContent="space-between"
// //     sx={{
// //       p: 1.5,
// //       borderRadius: 2,
// //       bgcolor: "#f8f9fa",
// //       border: "1px solid #ececec",
// //       mb: 1.5,
// //     }}
// //   >
// //     <Typography fontWeight={500}>{title}</Typography>

// //     <Box display="flex" alignItems="center">
// //       {status ? (
// //         <>
// //           <CheckCircleIcon color="success" sx={{ mr: 1 }} />
// //           <Typography color="success.main" fontWeight={600}>
// //             Ready
// //           </Typography>
// //         </>
// //       ) : (
// //         <>
// //           <CancelIcon color="error" sx={{ mr: 1 }} />
// //           <Typography color="error.main" fontWeight={600}>
// //             Pending
// //           </Typography>
// //         </>
// //       )}
// //     </Box>
// //   </Stack>
// // );

// // function PermissionStatus({ permissions }) {
// //   return (
// //     <Stack>
// //       <PermissionItem
// //         title="🎤 Microphone"
// //         status={permissions.microphone}
// //       />
// //       <PermissionItem 
// //         title="📷 Camera" 
// //         status={permissions.camera} 
// //       />
// //       <PermissionItem
// //         title="🖥 Screen Sharing"
// //         status={permissions.screen}
// //       />
// //     </Stack>
// //   );
// // }

// // ==========================================
// // 2. PreviewPanel Component
// // ==========================================
// function PreviewPanel({ permissions, setPermissions, candidate }) {

   

//   const [cameraOn, setCameraOn] = useState(false);

//   const toggleMic = () => {
//     setPermissions((prev) => ({
//       ...prev,
//       microphone: !prev.microphone,
//     }));
//   };

//   const toggleCamera = () => {
//     setCameraOn(!cameraOn);
//     setPermissions((prev) => ({
//       ...prev,
//       camera: !prev.camera,
//     }));
//   };

//   const toggleScreen = () => {
//     setPermissions((prev) => ({
//       ...prev,
//       screen: !prev.screen,
//     }));
//   };

//   return (
//     <Box
//       sx={{
//         bgcolor: "#1f1f1f",
//         borderRadius: 4,
//         overflow: "hidden",
//         position: "relative",
//         height: 650,
//       }}
//     >
//       {/* Preview */}
//       <Box
//         sx={{
//           height: "100%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           flexDirection: "column",
//         }}
//       >
//         <Avatar
//           sx={{
//             width: 110,
//             height: 110,
//             bgcolor: "#1976d2",
//             fontSize: 40,
//           }}
//         >
//           {candidate.name[0]}
//         </Avatar>

//         <Typography
//           mt={3}
//           color="white"
//           fontSize={28}
//           fontWeight={700}
//         >
//           {candidate.name}
//         </Typography>

//         <Typography color="#cfcfcf">Screen Preview</Typography>

//         <Typography mt={2} color="#7cff7c">
//           Ready for Interview
//         </Typography>
//       </Box>

//       {/* Bottom Controls */}
//       <Stack
//         direction="row"
//         spacing={3}
//         justifyContent="center"
//         sx={{
//           position: "absolute",
//           bottom: 25,
//           width: "100%",
//         }}
//       >
//         <IconButton
//           onClick={toggleMic}
//           sx={{
//             bgcolor: permissions.microphone ? "#34A853" : "#d93025",
//             color: "#fff",
//             width: 58,
//             height: 58,
//             "&:hover": {
//               bgcolor: permissions.microphone ? "#2d9448" : "#c62828",
//             },
//           }}
//         >
//           {permissions.microphone ? <MicIcon /> : <MicOffIcon />}
//         </IconButton>

//         <IconButton
//           onClick={toggleCamera}
//           sx={{
//             bgcolor: permissions.camera ? "#34A853" : "#d93025",
//             color: "#fff",
//             width: 58,
//             height: 58,
//             "&:hover": {
//               bgcolor: permissions.camera ? "#2d9448" : "#c62828",
//             },
//           }}
//         >
//           {permissions.camera ? <VideocamIcon /> : <VideocamOffIcon />}
//         </IconButton>

//         <IconButton
//           onClick={toggleScreen}
//           sx={{
//             bgcolor: permissions.screen ? "#34A853" : "#d93025",
//             color: "#fff",
//             width: 58,
//             height: 58,
//             "&:hover": {
//               bgcolor: permissions.screen ? "#2d9448" : "#c62828",
//             },
//           }}
//         >
//           {permissions.screen ? <ScreenShareIcon /> : <StopScreenShareIcon />}
//         </IconButton>

//         <IconButton
//           sx={{
//             bgcolor: "#3c4043",
//             color: "#fff",
//             width: 58,
//             height: 58,
//             "&:hover": {
//               bgcolor: "#5f6368",
//             },
//           }}
//         >
//           <SettingsIcon />
//         </IconButton>
//       </Stack>
//     </Box>
//   );
// }

// // ==========================================
// // 3. JoinPanel Component
// // ==========================================
// function JoinPanel({ candidate, permissions, onJoin }) {
//   const allGranted =
//     permissions.microphone && permissions.camera && permissions.screen;

//   return (
//     <Card
//       elevation={3}
//       sx={{
//         borderRadius: 4,
//         height: "100%",
//       }}
//     >
//       <CardContent sx={{ p: 4 }}>
//         <Typography variant="h5" fontWeight={700}>
//           Ready to Join
//         </Typography>

//         <Typography color="text.secondary" mt={1}>
//           Verify your details before joining the interview.
//         </Typography>

//         <Divider sx={{ my: 3 }} />

//         {/* Candidate Details */}
//         <Stack spacing={2}>
//           <Stack direction="row" spacing={2} alignItems="center">
//             <PersonIcon color="primary" />
//             <Box>
//               <Typography fontWeight={600}>Candidate</Typography>
//               <Typography color="text.secondary">{candidate.name}</Typography>
//             </Box>
//           </Stack>

//           <Stack direction="row" spacing={2} alignItems="center">
//             <BusinessIcon color="primary" />
//             <Box>
//               <Typography fontWeight={600}>Company</Typography>
//               <Typography color="text.secondary">{candidate.company}</Typography>
//             </Box>
//           </Stack>

//           <Stack direction="row" spacing={2} alignItems="center">
//             <AccessTimeIcon color="primary" />
//             <Box>
//               <Typography fontWeight={600}>Interview</Typography>
//               <Typography color="text.secondary">
//                 {candidate.interviewTime}
//               </Typography>
//               <Typography color="text.secondary">
//                 {candidate.duration}
//               </Typography>
//             </Box>
//           </Stack>
//         </Stack>

//         <Divider sx={{ my: 3 }} />

//         {/* Permissions Status Section */}
//         <Typography variant="h6" fontWeight={700} mb={2}>
//           Permission Status
//         </Typography>

//         {/* <PermissionStatus permissions={permissions} /> */}

//         <Divider sx={{ my: 3 }} />

//         {/* Overall Status Chip */}
//         <Chip
//           icon={allGranted ? <CheckCircleIcon /> : <CancelIcon />}
//           color={allGranted ? "success" : "warning"}
//           label={allGranted ? "Ready to Join" : "Permissions Pending"}
//           sx={{
//             width: "100%",
//             height: 45,
//             fontWeight: 600,
//           }}
//         />

//         <Button
//           fullWidth
//           size="large"
//           variant="contained"
//           disabled={!allGranted}
//           onClick={onJoin}
//           sx={{
//             mt: 4,
//             height: 56,
//             borderRadius: 3,
//             fontSize: 16,
//             textTransform: "none",
//             fontWeight: 700,
//           }}
//         >
//           Join Interview
//         </Button>

//         {!allGranted && (
//           <Typography
//             mt={2}
//             color="error"
//             fontSize={13}
//             textAlign="center"
//           >
//             Please allow Camera, Microphone and Screen Sharing.
//           </Typography>
//         )}
//       </CardContent>
//     </Card>
//   );
// }

// // ==========================================
// // 4. Main Component (Default Export)
// // ==========================================
// export default function InterviewLobby() {

//  const [searchParams] = useSearchParams();

// const jobTitle = searchParams.get("jobTitle");
// const clientName = searchParams.get("clientName");
// const fullName = searchParams.get("fullName");
// const date = searchParams.get("date");
// const time = searchParams.get("time");
// const timezone = searchParams.get("timezone");
// const interviewToken = searchParams.get("interviewToken");

//   const [permissions, setPermissions] = useState({
//     microphone: false,
//     camera: false,
//     screen: false,
//   });

//   const candidate = {
//     name: fullName,
//     position: jobTitle,
//     company: clientName,
//     interviewTime: `${time} (${timezone})`,
//     duration: "30 Minutes",
//   };

//   const handleJoin = () => {
//     alert("Start Interview");
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         bgcolor: "#f5f5f5",
//       }}
//     >
//       {/* Header */}
//       <AppBar
//         elevation={0}
//         position="static"
//         sx={{
//           bgcolor: "#fff",
//           color: "#000",
//           borderBottom: "1px solid #eee",
//         }}
//       >
//         <Toolbar>
//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: 700,
//             }}
//           >
//             AI Interview
//           </Typography>

//           <Box sx={{ flexGrow: 1 }} />

//           <Typography
//             sx={{
//               mr: 2,
//               color: "#555",
//             }}
//           >
//             {candidate.company}
//           </Typography>

//           <Avatar>R</Avatar>
//         </Toolbar>
//       </AppBar>

//       {/* Main Grid Content */}
//       <Box sx={{ p: 4 }}>
//         <Grid container spacing={4}>
//           {/* LEFT (Preview Panel) */}
//           <Grid item xs={12} md={8}>
//             <PreviewPanel
//               permissions={permissions}
//               setPermissions={setPermissions}
//               candidate={candidate}
//             />
//           </Grid>

//           {/* RIGHT (Join Panel) */}
//           <Grid item xs={12} md={4}>
//             <JoinPanel
//               permissions={permissions}
//               candidate={candidate}
//               onJoin={handleJoin}
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>
//   );
// }